<template>
  <div class="page-content">
    <!-- Main Steps -->
    <div class="pb-4">
      <!-- Main Steps UI -->
      <div
        class="d-flex align-items-center justify-content-between position-relative"
      >
        <template v-for="(step, index) in mainSteps" :key="index">
          <!-- Step Circle -->
          <div
            :class="{
              'disabled-step': !isOverallEdit && index + 1 > maxCurrentStep,
              'clickable-step': isOverallEdit || index + 1 <= maxCurrentStep,
            }"
            @click="redirecting(step)"
            class="text-center flex-grow-1"
          >
            <div
              class="rounded-circle d-flex justify-content-center align-items-center mx-auto"
              :style="{
                width: '40px',
                height: '40px',
                backgroundColor:
                  index + 1 < maxCurrentStep
                    ? '#28a745' // green for completed
                    : index + 1 === currentStep
                    ? step.color
                    : '#e8e8e8',
                color: index + 1 <= maxCurrentStep ? '#fff' : '#000',
              }"
              @click="currentStep = index + 1"
            >
              <template v-if="index + 1 < maxCurrentStep">
                <i class="mdi mdi-check text-white"></i>
              </template>
              <span v-else>
                {{ index + 1 }}
              </span>
            </div>
            <div
              class="mt-2 fw-semibold"
              :class="{
                'text-warning': index === currentStep - 1,
                'text-muted': index !== currentStep - 1,
              }"
            >
              {{ step.label }}
            </div>
          </div>

          <!-- Progress Line (skip after last step) -->
          <div
            v-if="index < mainSteps.length - 1"
            class="flex-grow-1 mx-2 position-relative"
            style="height: 4px; border-radius: 3px; background-color: #e4e6eb"
          >
            <!-- Completed part -->
            <div
              v-if="index < currentStep - 1"
              class="position-absolute top-0 start-0 h-100 bg-warning"
              style="border-radius: 3px; width: 100%"
            ></div>

            <div
              v-else-if="index === currentStep - 2"
              class="position-absolute top-0 start-0 h-100 bg-warning"
              :style="{
                animation: 'loaderAnim 1s linear forwards',
                borderRadius: '3px',
              }"
            ></div>
          </div>
        </template>
      </div>
    </div>

    <!-- Content -->
    <div class="card w-75 mb-5 text-center" style="margin: 0px auto">
      <!-- Heading -->
      <div @click="page_no = 1">
        <h4 class="fw-bold text-warning mt-3 mb-3" v-if="currentStep === 1">
          Operator Details
        </h4>
        <h4
          class="fw-bold text-warning mt-3 mb-3"
          v-else-if="currentStep === 2"
        >
          Bus Details
        </h4>
        <h4
          class="fw-bold text-warning mt-3 mb-3"
          v-else-if="currentStep === 3"
        >
          Route Details
        </h4>
        <h4 class="fw-bold text-warning mt-3 mb-3" v-else>Staff Details</h4>
      </div>
      <div
        v-if="!operatorOverview && !busOverview && !addMoreBus && !addMoreRoute"
      >
        <!-- Sub Heading Track -->
        <div
          v-if="currentStep !== 4"
          class="mt-2"
          style="
            height: 6px;
            width: 85%;
            background-color: #e5e7eb;
            margin: 0 auto;
            position: relative;
          "
        >
          <div
            :style="{
              height: '100%',
              width: progressWidth,
              backgroundColor: '#facc15',
              position: 'absolute',
              top: 0,
              left: 0,
              borderRadius: '3px',
              transition: 'width 0.5s ease-in-out',
            }"
          ></div>
        </div>
        <!-- Sub Headings -->
        <div class="pb-4 mt-4" v-if="currentStep !== 4">
          <div
            class="d-flex align-items-center justify-content-between position-relative"
          >
            <div
              v-for="(step, index) in subtitle"
              :key="index"
              class="text-center flex-grow-1"
              :class="{
                'disabled-step': !isOverallEdit && index + 1 > max_step,
                'clickable-step': isOverallEdit || index + 1 <= max_step,
              }"
              @click="handleStepClick(index + 1)"
            >
              <div
                class="rounded-circle border d-flex justify-content-center align-items-center mx-auto"
                :class="{
                  'border border-warning text-warning': index + 1 === page_no,
                }"
                :style="{
                  width: '40px',
                  height: '40px',
                  backgroundColor:
                    index + 1 < max_step
                      ? '#28a745'
                      : index + 1 === page_no
                      ? step.color
                      : '#e8e8e8',
                  color: index + 1 <= max_step ? '#fff' : '#000',
                }"
                style="width: 35px; height: 35px"
              >
                <template v-if="index + 1 < max_step">
                  <i class="mdi mdi-check text-white"></i>
                </template>
                <template v-else>
                  {{ index + 1 }}
                </template>
              </div>

              <div
                class="mt-2"
                :class="
                  index + 1 === page_no
                    ? 'fw-semibold text-warning'
                    : 'text-dark'
                "
              >
                {{ step }}
              </div>
            </div>
          </div>
        </div>
        <!-- Form -->
        <div v-if="currentStep === 1">
          <div id="orderList" v-if="page_no === 1">
            <div class="card-body" style="text-align: left">
              <div class="row g-3">
                <div class="input-container">
                  <label for="op_name" class="form-label fw-bold"
                    >Operator Name<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    id="op_name"
                    v-model="operatorDetails.name"
                    @input="v$.operatorDetails.name.$touch()"
                    class="form-control"
                    placeholder="Enter Operator Name"
                    required
                  />
                  <div class="error-message">
                    <span v-if="v$.operatorDetails.name.$errors.length">
                      {{ v$.operatorDetails.name.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="input-container">
                  <div>
                    <label for="op_phnno" class="form-label fw-bold"
                      >Phone Number<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      id="op_phnno"
                      v-model="operatorDetails.phone_number"
                      @input="v$.operatorDetails.phone_number.$touch()"
                      class="form-control"
                      maxlength="10"
                      placeholder="Enter Phone Number"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.operatorDetails.phone_number.$errors.length">
                      {{ v$.operatorDetails.phone_number.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="input-container">
                  <div>
                    <label for="op_email" class="form-label fw-bold"
                      >Email Id<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      id="op_email"
                      v-model="operatorDetails.email"
                      @input="v$.operatorDetails.email.$touch()"
                      class="form-control"
                      placeholder="Enter Email Id"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.operatorDetails.email.$errors.length">
                      {{ v$.operatorDetails.email.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div>
                  <div>
                    <label for="referal" class="form-label fw-bold"
                      >Referral Code (optional)</label
                    >
                    <input
                      type="text"
                      v-model="operatorDetails.referral_code"
                      id="referal"
                      class="form-control"
                      placeholder="Enter Referral Code"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="orderList" v-if="page_no === 2">
            <div class="card-body" style="text-align: left">
              <div>
                <h5 class="fw-bold">Choose any one</h5>
                <div class="d-flex gap-5">
                  <div>
                    <input
                      id="aadhar_label"
                      type="checkbox"
                      :checked="kyc_type === 'aadhar'"
                      @change="toggleSelection('aadhar')"
                      style="width: 16px; height: 16px"
                    />
                    <label for="aadhar_label" class="m-2 fw-bold"
                      >Aadhaar Card</label
                    >
                  </div>
                  <div class="d-flex align-items-center">
                    <input
                      id="pan_label"
                      type="checkbox"
                      :checked="kyc_type === 'pan'"
                      @change="toggleSelection('pan')"
                      style="width: 16px; height: 16px"
                    />
                    <label for="pan_label" class="m-2 fw-bold">Pan Card</label>
                  </div>
                </div>
              </div>
              <div class="row g-3 mt-2">
                <div class="col-lg-4 input-container">
                  <div v-if="kyc_type === 'pan'">
                    <label for="pan_num" class="form-label fw-bold"
                      >Pan Card Number<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="kycDetails.pan_no"
                      @input="v$.kycDetails.pan_no.$touch()"
                      id="pan_num"
                      class="form-control"
                      placeholder="Enter Pan Number"
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.kycDetails.pan_no.$errors.length">
                        {{ v$.kycDetails.pan_no.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div v-if="kyc_type === 'aadhar'">
                    <label for="aadhaar_num" class="form-label fw-bold"
                      >Aadhaar Card Number<span style="color: red"
                        >*</span
                      ></label
                    >
                    <input
                      v-model="kycDetails.aadhar_no"
                      @input="v$.kycDetails.aadhar_no.$touch()"
                      type="text"
                      id="aadhaar_num"
                      class="form-control"
                      maxlength="4"
                      placeholder="Enter Last 4 Digits  **** **** "
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.kycDetails.aadhar_no.$errors.length">
                        {{ v$.kycDetails.aadhar_no.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="orderList" v-if="page_no === 3">
            <div class="card-body" style="text-align: left">
              <div class="row g-3">
                <div class="input-container">
                  <div>
                    <label for="bank_name" class="form-label fw-bold"
                      >Bank Name<span style="color: red">*</span></label
                    >
                    <input
                      v-model="bankDetails.bank_name"
                      @input="v$.bankDetails.bank_name.$touch()"
                      type="text"
                      id="bank_name"
                      class="form-control"
                      placeholder="Enter Bank Name"
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.bankDetails.bank_name.$errors.length">
                        {{ v$.bankDetails.bank_name.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="input-container">
                  <div>
                    <label for="acc_num" class="form-label fw-bold"
                      >Account Number<span style="color: red">*</span></label
                    >
                    <input
                      v-model="bankDetails.acc_number"
                      @input="v$.bankDetails.acc_number.$touch()"
                      type="text"
                      id="acc_num"
                      class="form-control"
                      placeholder="Enter Account Number"
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.bankDetails.acc_number.$errors.length">
                        {{ v$.bankDetails.acc_number.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="input-container">
                  <div>
                    <label for="cnf_acc" class="form-label fw-bold"
                      >Confirm Account Number<span style="color: red"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      id="cnf_acc"
                      v-model="bankDetails.cnf_acc_no"
                      @input="v$.bankDetails.cnf_acc_no.$touch()"
                      class="form-control"
                      placeholder="Confirm Account Number"
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.bankDetails.cnf_acc_no.$errors.length">
                        {{ v$.bankDetails.cnf_acc_no.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="input-container">
                  <div>
                    <label for="ifsc" class="form-label fw-bold"
                      >IFSC Code<span style="color: red">*</span></label
                    >
                    <input
                      v-model="bankDetails.ifsc_code"
                      @input="v$.bankDetails.ifsc_code.$touch()"
                      type="text"
                      id="ifsc"
                      class="form-control"
                      placeholder="Enter IFSC Code"
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.bankDetails.ifsc_code.$errors.length">
                        {{ v$.bankDetails.ifsc_code.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="currentStep === 2 && !busOverview">
          <div id="orderList" class="border m-3 p-2 rounded">
            <!-- Heading -->
            <div class="border-bottom m-3">
              <h5 class="text-warning text-start" v-if="page_no === 1">
                BUS BASIC DETAILS
              </h5>
              <h5 class="text-warning text-start" v-else-if="page_no === 2">
                BUS IMAGES & RC BOOK UPLOAD
              </h5>
              <h5
                class="text-warning d-flex justify-content-between"
                v-else-if="page_no === 3"
              >
                <span> QR SCANNER</span
                ><span>
                  <button
                    v-if="routeDetails.from && routeDetails.to"
                    @click="downloadQrScanner"
                    class="btn btn-warning text-white border-0"
                  >
                    Download
                  </button>
                </span>
              </h5>
            </div>
            <!-- Basic Details form -->
            <div
              style="text-align: left"
              v-if="currentStep === 2 && page_no === 1"
              class="p-3"
            >
              <div class="row g-3">
                <div class="col-lg-6 input-container">
                  <label for="travels_name" class="form-label fw-bold"
                    >Travels Name<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    v-model="busBasicDetails.travelsName"
                    @input="v$.busBasicDetails.travelsName.$touch()"
                    id="travels_name"
                    class="form-control"
                    placeholder="Enter travels name"
                    required
                  />
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.travelsName.$errors.length">
                      {{ v$.busBasicDetails.travelsName.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="bus_regno" class="form-label fw-bold"
                      >Bus Registration Number<span style="color: red"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      v-model="busBasicDetails.busRegNo"
                      @input="v$.busBasicDetails.busRegNo.$touch()"
                      id="bus_regno"
                      class="form-control"
                      placeholder="Eg: TN 74 AV 0799"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.busRegNo.$errors.length">
                      {{ v$.busBasicDetails.busRegNo.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="bus_type" class="form-label fw-bold"
                      >Bus Type <span style="color: red">*</span></label
                    >
                    <select
                      v-model="busBasicDetails.busType"
                      @change="v$.busBasicDetails.busType.$touch()"
                      name=""
                      class="form-control"
                      id="bus_type"
                    >
                      <option value="seater">Seater</option>
                      <option value="sleeper">Sleeper</option>
                    </select>
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.busType.$errors.length">
                      {{ v$.busBasicDetails.busType.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="permit_type" class="form-label fw-bold"
                      >Permit Type<span style="color: red">*</span></label
                    >
                    <select
                      v-model="busBasicDetails.permitType"
                      @change="v$.busBasicDetails.permitType.$touch()"
                      class="form-control"
                      id="permit_type"
                    >
                      <option value="stageCarraige">Stage Carriage</option>
                      <option value="xxxx">xxxxx</option>
                    </select>
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.permitType.$errors.length">
                      {{ v$.busBasicDetails.permitType.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="bus_color" class="form-label fw-bold"
                      >Bus Color
                      <span class="fw-normal">(Optional)</span></label
                    >
                    <input
                      v-model="busBasicDetails.busColor"
                      type="text"
                      id="bus_color"
                      class="form-control"
                      placeholder="eg, White"
                      required
                    />
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="bus_capacity" class="form-label fw-bold"
                      >Bus capacity<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      id="bus_capacity"
                      v-model="busBasicDetails.busCapacity"
                      @input="v$.busBasicDetails.busCapacity.$touch()"
                      class="form-control"
                      maxlength="10"
                      placeholder="Enter total seats"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.busCapacity.$errors.length">
                      {{ v$.busBasicDetails.busCapacity.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="bus_make" class="form-label fw-bold"
                      >Bus Make<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="busBasicDetails.busMake"
                      @input="v$.busBasicDetails.busMake.$touch()"
                      id="bus_make"
                      class="form-control"
                      placeholder="eg:Ashok leyland"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.busMake.$errors.length">
                      {{ v$.busBasicDetails.busMake.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="bus_district" class="form-label fw-bold">
                      Bus District<span style="color: red">*</span>
                    </label>

                    <select
                      v-model="selectedDistrict"
                      @change="onDistrictChange"
                      class="form-select"
                      id="bus_district"
                      required
                    >
                      <option value="" disabled>Select a district</option>
                      <option
                        v-for="city in availableCities"
                        :key="city"
                        :value="city"
                      >
                        {{ city }}
                      </option>
                      <option value="other">Other</option>
                    </select>
                  </div>

                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.busDistrict.$errors.length">
                      {{ v$.busBasicDetails.busDistrict.$errors[0].$message }}
                    </span>
                  </div>
                </div>

                <div
                  class="col-lg-12 input-container"
                  v-if="showCustomDistrict"
                >
                  <label for="bus_district" class="form-label fw-bold">
                    Enter Bus District<span style="color: red">*</span>
                  </label>
                  <input
                    v-model="busBasicDetails.busDistrict"
                    @input="v$.busBasicDetails.busDistrict.$touch()"
                    type="text"
                    class="form-control mt-2"
                    placeholder="Enter custom district"
                  />
                </div>

                <div class="col-lg-6 input-container">
                  <div>
                    <label for="base_location" class="form-label fw-bold"
                      >Base Location<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="busBasicDetails.baseLocation"
                      @input="v$.busBasicDetails.baseLocation.$touch()"
                      id="base_location"
                      class="form-control"
                      placeholder="Enter base location"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.baseLocation.$errors.length">
                      {{ v$.busBasicDetails.baseLocation.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="pin_code" class="form-label fw-bold"
                      >Pin Code <span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="busBasicDetails.pincode"
                      @input="v$.busBasicDetails.pincode.$touch()"
                      id="pin_code"
                      class="form-control"
                      maxlength="6"
                      placeholder="Enter pincode"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.busBasicDetails.pincode.$errors.length">
                      {{ v$.busBasicDetails.pincode.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Bus Images & Rc book -->
            <div
              style="text-align: left"
              v-if="currentStep === 2 && page_no === 2"
            >
              <div class="container mt-2">
                <!-- Bus Image Upload -->
                <label
                  class="upload-area w-100 mb-5"
                  for="busImageInput"
                  style="min-height: 150px"
                >
                  <div v-if="images.busImages.length === 0">
                    <i class="ri-upload-cloud-line mb-3 d-block"></i>
                    <p>Drag & drop or click to upload bus images</p>
                    <small>PNG, JPG or JPEG (max. 5MB)</small>
                  </div>

                  <div
                    v-else
                    class="d-flex flex-column justify-content-center align-items-center"
                    style="height: 100%"
                  >
                    <i class="ri-upload-cloud-line mb-2"></i>
                    <small>Click to upload more images (Max 6)</small>
                  </div>

                  <input
                    type="file"
                    id="busImageInput"
                    accept="image/png, image/jpeg"
                    multiple
                    @change="handleBusImageUpload"
                    :disabled="images.busImages.length >= 6"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      opacity: 0;
                      cursor: pointer;
                    "
                  />
                </label>
                <div
                  v-if="v$.images.busImages.$error"
                  class="text-danger small mt-2"
                >
                  <span v-if="!v$.images.busImages.required"
                    >At least 1 bus image is required.</span
                  >
                  <span v-else-if="!v$.images.busImages.minLength"
                    >Please upload at least one bus image.</span
                  >
                </div>

                <div v-if="images.busImages.length" class="row g-4 mt-3">
                  <div
                    class="col-md-4"
                    v-for="(img, index) in images.busImages"
                    :key="index"
                  >
                    <div
                      class="card image-card"
                      @mouseenter="hoverIndex = index"
                      @mouseleave="hoverIndex = null"
                    >
                      <div class="image-wrapper">
                        <img
                          :src="img.image_url"
                          alt="Bus Image"
                          class="card-img-top"
                        />
                        <!-- Hover Delete Icon -->
                        <i
                          v-if="hoverIndex === index"
                          class="ri-close-circle-fill delete-icon"
                          @click="openDeleteDialog(img, index)"
                        ></i>
                      </div>

                      <div class="card-body">
                        <select v-model="img.image_type" class="form-control">
                          <option
                            v-for="type in imageTypes"
                            :key="type"
                            :value="type"
                            :disabled="isTypeSelected(type, index)"
                          >
                            {{ type.charAt(0).toUpperCase() + type.slice(1) }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- RC Book Upload -->
                <h5 class="fw-bold mb-1 mt-5">RC Book Upload</h5>
                <p class="text-muted mb-4">
                  Upload clear images of your RC book. Make sure text is clear
                  and readable.
                </p>

                <div class="row g-4">
                  <!-- RC Book Front -->
                  <div class="col-md-6">
                    <label
                      for="rcFront"
                      class="upload-area w-100"
                      style="height: 250px; position: relative"
                    >
                      <template v-if="images.rcFrontImage.file">
                        <img
                          :src="previrwRcFront"
                          alt="RC Front"
                          class="w-100 h-100"
                          style="object-fit: cover"
                        />
                      </template>
                      <template v-else>
                        <i class="ri-image-line mb-3 d-block"></i>
                        <p>Upload RC Book Front</p>
                        <small>PNG, JPG or JPEG (max. 5MB)</small>
                      </template>
                      <input
                        type="file"
                        id="rcFront"
                        accept="image/png, image/jpeg"
                        @change="handleRcFrontUpload"
                        style="
                          position: absolute;
                          top: 0;
                          left: 0;
                          width: 100%;
                          height: 100%;
                          opacity: 0;
                          cursor: pointer;
                        "
                      />
                    </label>
                  </div>

                  <!-- RC Book Back -->
                  <div class="col-md-6">
                    <label
                      for="rcBack"
                      class="upload-area w-100"
                      style="height: 250px; position: relative"
                    >
                      <template v-if="images.rcBackImage.file">
                        <img
                          :src="previewRcBack"
                          alt="RC Back"
                          class="w-100 h-100"
                          style="object-fit: cover"
                        />
                      </template>
                      <template v-else>
                        <i class="ri-image-line mb-3 d-block"></i>
                        <p>Upload RC Book Back</p>
                        <small>PNG, JPG or JPEG (max. 5MB)</small>
                      </template>
                      <input
                        type="file"
                        id="rcBack"
                        accept="image/png, image/jpeg"
                        @change="handleRcBackUpload"
                        style="
                          position: absolute;
                          top: 0;
                          left: 0;
                          width: 100%;
                          height: 100%;
                          opacity: 0;
                          cursor: pointer;
                        "
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- QR section -->
            <div
              v-if="page_no === 3 && currentStep === 2"
              class="p-3 d-flex justify-content-center"
            >
              <div
                ref="qrSection"
                style="
                  background-color: yellow;
                  width: 450px;
                  padding: 30px 20px;
                  font-family: Verdana, Geneva, Tahoma, sans-serif;
                "
              >
                <br />
                <strong
                  style="
                    color: black;
                    margin-top: 6px;
                    font-size: 28px;
                    font-weight: 900;
                  "
                >
                  Scan to book Ticket
                </strong>
                <div
                  class="d-flex gap-2 justify-content-center align-items-center mt-4"
                  v-if="routeDetails.from && routeDetails.to"
                >
                  <div>
                    <span class="fs-4 fw-bold"> {{ routeDetails.from }} </span>
                  </div>
                  <div>
                    <i class="ri-arrow-left-right-fill"></i>
                  </div>
                  <div>
                    <span class="fs-4 fw-bold"> {{ routeDetails.to }} </span>
                  </div>
                </div>
                <div v-else>No Routes Added yet</div>
                <br />
                <br />
                <QrScanner
                  ref="qrRef"
                  :ticketId="this.bus_id"
                  :showBookingID="false"
                />
                <br />
                <br />
                <div style="padding: 0px 20px 20px; color: black">
                  <h3 style="color: black">
                    Install Routebus
                    <span class="mdi mdi-arrow-right-thin"></span> Signup
                    <span class="mdi mdi-arrow-right-thin"></span> Get ₹50 Bonus
                    <span class="mdi mdi-arrow-right-thin"></span> Scan & Book
                  </h3>
                </div>

                <div style="margin: 10px">
                  <div>
                    <img src="/images/fav.png" alt="Logo" width="50px" />
                  </div>
                  <strong
                    style="color: black; font-size: 24px; font-weight: 700"
                  >
                    {{ busBasicDetails.travelsName.toUpperCase() }}</strong
                  ><br />
                  <span style="font-size: 12px">POWERED BY ROUTEBUS </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="currentStep === 3">
          <div id="orderList" class="border m-3 p-2 rounded">
            <!-- Heading -->
            <div class="border-bottom m-3">
              <h5 class="text-warning text-start" v-if="page_no === 1">
                ROUTE DETAILS
              </h5>
              <h5 class="text-warning text-start" v-else-if="page_no === 2">
                STOP TABLE
              </h5>
              <h5 class="text-warning text-start" v-else-if="page_no === 3">
                FAIR TABLE
              </h5>
              <h5 class="text-warning text-start" v-else-if="page_no === 4">
                TRIP TABLE
              </h5>
              <h5 class="text-warning text-start" v-else-if="page_no === 5">
                TIME TABLE
              </h5>
            </div>
            <!-- Route Details -->
            <div v-if="page_no === 1 && currentStep === 3" class="p-3">
              <div class="row g-3" style="text-align: left">
                <div class="col-lg-6 input-container">
                  <label for="from" class="form-label fw-bold"
                    >From<span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    id="from"
                    v-model="routeDetails.from"
                    @input="v$.routeDetails.from.$touch()"
                    class="form-control"
                    placeholder="Starting Point"
                    required
                  />
                  <div class="error-message">
                    <span v-if="v$.routeDetails.from.$errors.length">
                      {{ v$.routeDetails.from.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="via" class="form-label fw-bold"
                      >via<span class="fw-normal">(optional)</span></label
                    >
                    <input
                      type="text"
                      v-model="routeDetails.via"
                      id="via"
                      class="form-control"
                      placeholder="important stops en route"
                      required
                    />
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="to" class="form-label fw-bold"
                      >To <span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="routeDetails.to"
                      @input="v$.routeDetails.to.$touch()"
                      id="to"
                      class="form-control"
                      placeholder="Destination Point"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.routeDetails.to.$errors.length">
                      {{ v$.routeDetails.to.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="to" class="form-label fw-bold"
                      >Total Number of Stops<span style="color: red"
                        >*</span
                      ></label
                    >
                    <input
                      v-model="routeDetails.noOfStops"
                      @input="v$.routeDetails.noOfStops.$touch()"
                      type="text"
                      id="op_name"
                      class="form-control"
                      placeholder="eg: 10"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.routeDetails.noOfStops.$errors.length">
                      {{ v$.routeDetails.noOfStops.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="total_km" class="form-label fw-bold"
                      >Total KMs Covered
                      <span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="routeDetails.totalKm"
                      @input="v$.routeDetails.totalKm.$touch()"
                      id="total_km"
                      class="form-control"
                      maxlength="10"
                      placeholder="eg, 250"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.routeDetails.totalKm.$errors.length">
                      {{ v$.routeDetails.totalKm.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="min_fare" class="form-label fw-bold"
                      >Minimum Fare($)<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="routeDetails.minimumFare"
                      @input="v$.routeDetails.minimumFare.$touch()"
                      id="min_fare"
                      class="form-control"
                      placeholder="Lowest Fare Amount"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.routeDetails.minimumFare.$errors.length">
                      {{ v$.routeDetails.minimumFare.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="max_fare" class="form-label fw-bold"
                      >Maximum Fare<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="routeDetails.maximumFare"
                      @input="v$.routeDetails.maximumFare.$touch()"
                      id="max_fare"
                      class="form-control"
                      maxlength="10"
                      placeholder="Highest Fare Amount"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.routeDetails.maximumFare.$errors.length">
                      {{ v$.routeDetails.maximumFare.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div class="col-lg-6 input-container">
                  <div>
                    <label for="lug_fare" class="form-label fw-bold"
                      >Luggage Fare per Unit<span style="color: red"
                        >*</span
                      ></label
                    >
                    <input
                      type="text"
                      v-model="routeDetails.luggageFare"
                      @input="v$.routeDetails.luggageFare.$touch()"
                      id="lug_fare"
                      class="form-control"
                      placeholder="Charge per kg or piece"
                      required
                    />
                  </div>
                  <div class="error-message">
                    <span v-if="v$.routeDetails.luggageFare.$errors.length">
                      {{ v$.routeDetails.luggageFare.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Trip Table -->
            <div v-if="page_no === 2 && currentStep === 3" class="p-3">
              <table
                style="width: 100%; border-collapse: collapse; text-align: left"
              >
                <thead>
                  <tr style="border-bottom: 1px solid #ccc">
                    <th class="p-3">Stop</th>
                    <th>Stop Name</th>
                    <th>ETA from Starting Point Minutes</th>
                    <th>Distance from Starting Point KMs</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(stop, i) in order_of_stops || []"
                    :key="i"
                    style="border-bottom: 1px solid #eee; height: 50px"
                    class="p-3"
                  >
                    <td>
                      {{
                        i === 0
                          ? "From"
                          : i === order_of_stops.length - 1
                          ? "To"
                          : `Stop ${i}`
                      }}
                    </td>
                    <!-- Stop Name -->
                    <td>
                      <div v-if="editingRowIndex === i">
                        <input
                          v-model="stop.stop"
                          :class="{
                            'error-border':
                              v$.order_of_stops?.$each?.[i]?.stop?.$error,
                          }"
                        />
                        <div
                          v-if="v$.order_of_stops?.$each?.[i]?.stop?.$error"
                          class="error-text"
                        >
                          Stop Name is required
                        </div>
                      </div>
                      <div v-else>{{ stop.stop || "Stop Name" }}</div>
                    </td>

                    <!-- ETA -->
                    <td>
                      <div v-if="editingRowIndex === i">
                        <input
                          v-model="stop.time"
                          :class="{
                            'error-border':
                              v$.order_of_stops?.$each?.[i]?.time?.$error,
                          }"
                        />
                        <div
                          v-if="v$.order_of_stops?.$each?.[i]?.time?.$error"
                          class="error-text"
                        >
                          Valid ETA required
                        </div>
                      </div>
                      <div v-else>
                        {{
                          stop.time !== undefined && stop.time !== null
                            ? stop.time
                            : "Add ETA"
                        }}
                      </div>
                    </td>

                    <!-- Distance -->
                    <td>
                      <div v-if="editingRowIndex === i">
                        <input
                          v-model="stop.distance"
                          :class="{
                            'error-border':
                              v$.order_of_stops?.$each?.[i]?.distance?.$error,
                          }"
                        />
                        <div
                          v-if="v$.order_of_stops?.$each?.[i]?.distance?.$error"
                          class="error-text"
                        >
                          Valid Distance required
                        </div>
                      </div>
                      <div v-else>
                        {{
                          stop.distance !== undefined && stop.distance !== null
                            ? stop.distance
                            : "Add Distance"
                        }}
                      </div>
                    </td>

                    <!-- Actions -->
                    <td class="text-center">
                      <i
                        v-if="editingRowIndex !== i"
                        class="ri-pencil-line fs-5"
                        style="cursor: pointer"
                        @click="editingRowIndex = i"
                      ></i>

                      <i
                        v-else
                        class="ri-check-line text-green-600 fs-5"
                        style="cursor: pointer"
                        @click="editingRowIndex = null"
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Fare Table -->
            <div v-if="page_no === 3 && currentStep === 3" class="p-3">
              <div style="text-align: left">
                <h3>Fare Matrix</h3>
                <p>
                  Define the fare between each pair of stops. The grid shows all
                  possible combinations.
                </p>

                <div class="d-flex justify-content-end mb-2">
                  <button
                    class="btn btn-warning text-white border-0"
                    @click="toggleEdit"
                  >
                    {{ isFareTableEditing ? "Save" : "Edit" }}
                  </button>
                </div>

                <table class="fare-table">
                  <thead>
                    <tr>
                      <th>From / To</th>
                      <th v-for="to in order_of_stops" :key="to.stop">
                        {{ to.stop }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(from, i) in order_of_stops" :key="from.stop">
                      <td>{{ from.stop }}</td>
                      <td v-for="(to, j) in order_of_stops" :key="to.stop">
                        <span v-if="j <= i">-</span>
                        <span v-else>
                          <span
                            v-if="isFareTableEditing"
                            class="fare-input-wrapper"
                          >
                            <input
                              type="number"
                              v-model.number="getFareObject(from, to).fare"
                              min="0"
                              class="fare-input"
                            />
                          </span>
                          <span v-else>
                            ₹{{ getFareObject(from, to)?.fare ?? "-" }}
                          </span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="fare-instructions">
                  <p><strong>Instructions:</strong></p>
                  <ul>
                    <li>Enter fare amount (in ₹) between each pair of stops</li>
                    <li>Same stop combinations are marked with “-”</li>
                    <li>Backward journey combinations can be made optional</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Trip Table -->
            <div v-if="page_no === 4 && currentStep === 3" class="p-3">
              <div class="container mt-4">
                <table class="table table-bordered table-striped">
                  <thead class="table-dark">
                    <tr>
                      <th>S.No</th>
                      <th>Trip Type</th>
                      <th>Trip ID</th>
                      <th>Trip Start Time</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="trips.length === 0">
                      <td colspan="5" class="text-center">No data</td>
                    </tr>
                    <tr v-for="(trip, index) in trips" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>
                        <select
                          :disabled="
                            trip.hasOwnProperty('editable')
                              ? !trip.editable
                              : !!trip.trip_id
                          "
                          v-model="trip.trip_type"
                          class="form-select"
                        >
                          <option value="up">Up</option>
                          <option value="down">Down</option>
                        </select>
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control"
                          v-model="trip.trip_id"
                          :disabled="true"
                        />
                      </td>
                      <td>
                        <input
                          type="time"
                          class="form-control"
                          v-model="trip.trip_start_time"
                          :disabled="
                            trip.hasOwnProperty('editable')
                              ? !trip.editable
                              : !!trip.trip_id
                          "
                        />
                      </td>
                      <td class="text-center">
                        <button
                          class="btn btn-outline-primary btn-md me-1"
                          @click="toggleEditTrip(trip, index)"
                        >
                          <i
                            :class="
                              trip.editable ? 'ri-save-line' : 'ri-edit-line'
                            "
                          ></i>
                        </button>
                        <button
                          class="btn btn-outline-danger btn-md"
                          @click="removeTrip(trip, index)"
                        >
                          <i class="ri-delete-bin-line"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center mb-2">
                  <button
                    class="btn rounded-circle text-white"
                    @click="addTrip"
                    style="width: 45px; height: 40px; background-color: #807f81"
                  >
                    <i class="ri-add-line"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- Time Table -->
            <div v-if="page_no === 5 && currentStep === 3" class="p-3">
              <div class="container-fluid" style="text-align: left">
                <!-- Header -->
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <div>
                    <h5 class="fw-bold mb-1">Time Table</h5>
                    <small class="text-muted">
                      View and edit the schedule for each trip and stop.
                    </small>
                  </div>
                  <button
                    @click="exportTableToCSV"
                    class="btn btn-outline-secondary"
                  >
                    <i class="bi bi-download"></i> Export CSV
                  </button>
                </div>

                <!-- Timetable Table -->
                <div class="timetable-wrapper">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <h5 class="mb-0">Bus Route Timetable</h5>
                    <div>
                      <button
                        v-if="!isTimeTableEditing"
                        class="btn btn-outline-primary btn-sm"
                        @click="startEditing"
                      >
                        Edit
                      </button>
                      <div v-else>
                        <button
                          class="btn btn-success btn-sm me-2"
                          @click="saveChanges"
                        >
                          Save
                        </button>
                        <button
                          class="btn btn-secondary btn-sm"
                          @click="cancelChanges"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive small-table">
                    <table class="table table-sm table-bordered table-striped">
                      <thead class="table-light">
                        <tr>
                          <th>Type</th>
                          <th>ID</th>
                          <th>Trip Details</th>
                          <th v-for="stop in uniqueStops" :key="stop">
                            {{ stop }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(timetable, index) in displayTimetables"
                          :key="index"
                        >
                          <td>{{ timetable.trip_type }}</td>
                          <td>{{ timetable.trip_id }}</td>
                          <td>Trip {{ index + 1 }}</td>

                          <td v-for="stop in uniqueStops" :key="stop">
                            <input
                              v-if="isTimeTableEditing"
                              type="time"
                              class="form-control form-control-sm"
                              v-model="timetable.time_table_obj[stop]"
                            />
                            <span v-else>{{
                              timetable.time_table_obj[stop] || "--"
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <!-- staff Table -->
          <div
            class="border-bottom m-3 d-flex align-center justify-content-between bg-red"
          >
            <!-- Headings -->
            <div
              v-if="page_no === 1 && currentStep === 4"
              class="d-flex justify-content-between w-100 align-items-center"
            >
              <h5 class="text-dark fw-bold m-0 p-0">Staff Management</h5>

              <button
                data-bs-toggle="modal"
                data-bs-target="#addStaffModal"
                class="bg-success text-white border-0 p-2 rounded-2 d-flex align-items-center"
              >
                <i class="ri-add-line me-2"></i>
                Add Staff
              </button>
            </div>
          </div>

          <div v-if="currentStep === 4" class="p-3 text-start">
            <div class="table-responsive table-card mb-1 mt-4">
              <table class="table w-100">
                <thead class="bg-light">
                  <tr>
                    <th class="fw-semibold text-muted py-3">Name</th>
                    <th class="fw-semibold text-muted">Phone Number</th>
                    <th class="fw-semibold text-muted">Role</th>
                    <th class="fw-semibold text-muted">Linked Buses</th>
                    <th class="fw-semibold text-muted">Status</th>
                    <th class="fw-semibold text-muted">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  <!-- Staff rows -->
                  <tr v-for="(staff, index) in staffData" :key="index">
                    <td class="py-3">
                      <strong>{{ staff.name }}</strong>
                    </td>
                    <td>
                      <strong>{{ staff.phone_number }}</strong>
                    </td>
                    <td>
                      <span :class="['role-label', getRoleClass(staff.role)]">
                        {{ staff.role }}
                      </span>
                    </td>
                    <td>
                      <span
                        v-for="(bus, index) in staff?.bus_details"
                        :key="index"
                        class="role-label"
                      >
                        {{ bus.reg_no }}
                      </span>
                    </td>
                    <td>
                      <div class="form-check form-switch d-flex">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          :id="'statusSwitch' + index"
                          v-model="staff.is_active"
                          @change="updateStatus(staff)"
                        />
                      </div>
                    </td>
                    <td>
                      <i
                        class="ri-pencil-line fs-5 text-success p-2 rounded"
                        @click="editStaff(index)"
                      ></i>
                      <i
                        class="ri-delete-bin-line fs-5 text-danger p-2 rounded"
                        @click="deleteStaff(staff)"
                      ></i>
                    </td>
                  </tr>

                  <tr v-if="staffData.length === 0">
                    <td colspan="6" class="text-center py-4">
                      <div class="alert alert-info fs-6" role="alert">
                        NO STAFF FOUND. ADD STAFF !
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="d-flex justify-content-end">
              <button
                @click="final"
                style="
                  height: 40px;
                  width: 140px;
                  background-color: #eab308;
                  color: white;
                  border: none;
                "
                class="d-flex align-center justify-content-center pt-2 rounded"
                :disabled="staffData.length === 0"
                :class="[
                  'btn',
                  {
                    'btn-soft-warning': !staffData.length === 0,
                    'btn-grey': staffData.length === 0,
                  },
                ]"
              >
                Finish
              </button>
            </div>

            <!-- Add Staff Modal -->
            <div
              class="modal fade"
              id="addStaffModal"
              tabindex="-1"
              aria-labelledby="addStaffModalLabel"
              aria-hidden="true"
              ref="addStaffModalRef"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title fw-bold" id="addStaffModalLabel">
                      Add New Staff Member
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <form>
                      <div class="mb-3">
                        <label for="staffName" class="form-label">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          v-model="staffdetails.name"
                          @input="v$.staffdetails.name.$touch()"
                          id="staffName"
                          placeholder="Enter name"
                          required
                        />
                        <div class="error-message">
                          <span v-if="v$.staffdetails.name.$errors.length">
                            {{ v$.staffdetails.name.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="staffPhone" class="form-label"
                          >Phone Number</label
                        >
                        <input
                          type="text"
                          v-model="staffdetails.phone_number"
                          @input="v$.staffdetails.phone_number.$touch()"
                          class="form-control"
                          maxlength="10"
                          id="staffPhone"
                          placeholder="Enter phone number"
                          required
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.staffdetails.phone_number.$errors.length"
                          >
                            {{
                              v$.staffdetails.phone_number.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label for="staffRole" class="form-label">Role</label>
                        <select
                          v-model="staffdetails.role"
                          @change="v$.staffdetails.role.$touch()"
                          class="form-select"
                          id="staffRole"
                          required
                        >
                          <option selected disabled value="">
                            Select role
                          </option>
                          <option value="driver">Driver</option>
                          <option value="conductor">Conductor</option>
                          <option value="checker">Checker</option>
                        </select>
                        <div class="error-message">
                          <span v-if="v$.staffdetails.role.$errors.length">
                            {{ v$.staffdetails.role.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label">Linked buses</label>
                        <div
                          class="d-flex align-items-center mb-2"
                          v-for="(bus, index) in totalNoOfBuses"
                          :key="bus.bus_id"
                        >
                          <input
                            type="checkbox"
                            :id="'linkedBuses-' + index"
                            :value="bus.bus_id"
                            v-model="staffdetails.linked_buses"
                          />
                          <label
                            class="form-label mt-2 ms-2"
                            :for="'linkedBuses-' + index"
                          >
                            {{ bus.reg_no }}
                          </label>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="btn"
                      :disabled="loading || !isStaffValid"
                      :class="{
                        'btn-secondary': !loading && isStaffValid,
                        'btn-soft-warning': !loading && !isStaffValid,
                        'btn-grey': loading || !isStaffValid,
                      }"
                      @click="submitStaff"
                    >
                      <div
                        v-if="loading"
                        class="spinner-border spinner-border-sm text-white"
                        role="status"
                      ></div>
                      <div v-else class="text-white">Add</div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Error Message -->
        <div class="m-2">
          <div
            :class="'alert alert-' + msgType + ' mb-xl-0'"
            role="alert"
            v-if="msgTxt && msgTxt.length > 0"
          >
            {{ msgTxt }}
          </div>
        </div>

        <!-- Save btn -->
        <div class="m-2 mb-4" v-if="currentStep === 1">
          <button
            :disabled="loading || !isCurrentTabValid"
            style="height: 45px; width: 100%; background-color: #eab308"
            v-if="page_no <= this.subtitle.length"
            type="button"
            @click="validate"
            :class="[
              'btn',
              {
                'btn-soft-warning': !(loading || !isCurrentTabValid),
                'btn-grey': loading || !isCurrentTabValid,
              },
            ]"
          >
            <div
              v-if="loading"
              style="height: 30px"
              class="spinner-border text-white"
              role="status"
            ></div>
            <div v-else class="text-white">Save</div>
          </button>
        </div>

        <!-- Next and previous btn -->
        <div
          v-if="
            (currentStep === 2 || currentStep === 3) &&
            !busOverview &&
            !addMoreBus &&
            !addMoreRoute
          "
          class="d-flex justify-content-end m-2"
        >
          <button
            @click="validate"
            style="
              height: 40px;
              width: 140px;
              background-color: #eab308;
              color: white;
              border: none;
            "
            class="d-flex align-center justify-content-center pt-2 rounded"
            :disabled="loading || !isCurrentTabValid"
            :class="[
              'btn',
              {
                'btn-soft-warning': !(loading || !isCurrentTabValid),
                'btn-grey': loading || !isCurrentTabValid,
              },
            ]"
          >
            <div
              v-if="loading"
              class="spinner-border spinner-border-sm text-white"
              role="status"
            ></div>
            <div v-else class="text-white">
              Next <i class="ri-arrow-right-line mx-1"></i>
            </div>
          </button>
        </div>
      </div>
      <!-- Overview Page -->
      <div
        class="card m-5 p-5 box-shadow"
        v-if="currentStep === 1 && operatorOverview"
      >
        <h5 class="text-warning fw-bold">Operator Details Summary</h5>

        <!-- Basic Details -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="fw-bold fs-5">Basic Details</span>
          <button
            v-if="!isEditing.basic"
            style="width: 100px"
            :disabled="isEditing.kyc || isEditing.bank"
            class="btn btn-outline-warning btn-md"
            @click="isEditing.basic = true"
          >
            <span class="mdi mdi-pencil"></span>
            Edit
          </button>
          <button
            :disabled="isEditing.kyc || isEditing.bank"
            @click="updateOperator()"
            v-if="isEditing.basic"
            class="btn btn-warning btn-md"
          >
            <div
              class="spinner-border spinner-border-sm text-white"
              role="status"
              v-if="loading"
            ></div>
            <div v-else>Save</div>
          </button>
        </div>
        <div class="p-3 text-start" style="background-color: #f7f7f7">
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <label style="width: 50%">Name:</label>
            <div style="width: 50%">
              <div v-if="isEditing.basic">
                <input
                  type="text"
                  class="form-control"
                  v-model="operatorDetails.name"
                  @input="v$.operatorDetails.name.$touch()"
                />
                <div class="error-message">
                  <span v-if="v$.operatorDetails.name.$errors.length">
                    {{ v$.operatorDetails.name.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div v-else>
                <strong>{{ operatorDetails.name }}</strong>
              </div>
            </div>
          </div>
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <label style="width: 50%">Phone Number:</label>
            <div style="width: 50%">
              <div v-if="isEditing.basic">
                <input
                  type="text"
                  class="form-control"
                  v-model="operatorDetails.phone_number"
                  @input="v$.operatorDetails.phone_number.$touch()"
                />
                <div class="error-message">
                  <span v-if="v$.operatorDetails.phone_number.$errors.length">
                    {{ v$.operatorDetails.phone_number.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div v-else>
                <strong>{{ operatorDetails.phone_number }}</strong>
              </div>
            </div>
          </div>
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <label style="width: 50%">E-Mail:</label>
            <div style="width: 50%">
              <div v-if="isEditing.basic">
                <input
                  type="text"
                  class="form-control"
                  v-model="operatorDetails.email"
                  @input="v$.operatorDetails.email.$touch()"
                />
                <div class="error-message">
                  <span v-if="v$.operatorDetails.email.$errors.length">
                    {{ v$.operatorDetails.email.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div v-else>
                <strong>{{ operatorDetails.email }}</strong>
              </div>
            </div>
          </div>
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <label style="width: 50%">Refferal code:</label>
            <div style="width: 50%">
              <div v-if="isEditing.basic">
                <input
                  type="text"
                  class="form-control"
                  v-model="operatorDetails.referral_code"
                />
              </div>
              <div v-else>
                <strong>{{
                  operatorDetails.referral_code
                    ? operatorDetails.referral_code
                    : "---------"
                }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- KYC Details -->
        <div
          class="d-flex justify-content-between align-items-center mt-3 mb-2"
        >
          <span class="fw-bold fs-5">KYC Details</span>
          <button
            v-if="!isEditing.kyc"
            style="width: 100px"
            :disabled="isEditing.basic || isEditing.bank"
            class="btn btn-outline-warning btn-md"
            @click="isEditing.kyc = true"
          >
            <span class="mdi mdi-pencil"></span>
            Edit
          </button>
          <button
            @click="updateKycDetails()"
            v-if="isEditing.kyc"
            :disabled="isEditing.basic || isEditing.bank"
            class="btn btn-warning btn-md"
          >
            <div
              class="spinner-border spinner-border-sm text-white"
              role="status"
              v-if="loading"
            ></div>
            <div v-else>Save</div>
          </button>
        </div>
        <div class="p-3 text-start" style="background-color: #f7f7f7">
          <!-- KYC Number Field -->
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <label style="width: 50%">KYC Number:</label>
            <div style="width: 50%">
              <div v-if="isEditing.kyc">
                <div v-if="kyc_type === 'pan'">
                  <input
                    type="text"
                    v-model="kycDetails.pan_no"
                    @input="v$.kycDetails.pan_no.$touch()"
                    class="form-control"
                    placeholder="Enter PAN Number"
                    required
                  />
                  <div class="error-message">
                    <span v-if="v$.kycDetails.pan_no.$errors.length">
                      {{ v$.kycDetails.pan_no.$errors[0].$message }}
                    </span>
                  </div>
                </div>
                <div v-else>
                  <input
                    type="text"
                    v-model="kycDetails.aadhar_no"
                    @input="v$.kycDetails.aadhar_no.$touch()"
                    class="form-control"
                    placeholder="Enter Aadhaar Number"
                    required
                  />
                  <div class="error-message">
                    <span v-if="v$.kycDetails.aadhar_no.$errors.length">
                      {{ v$.kycDetails.aadhar_no.$errors[0].$message }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else>
                <strong>{{ kyc_value }}</strong>
              </div>
            </div>
          </div>

          <!-- KYC Type Field -->
          <div class="mb-2 d-flex justify-content-between align-items-center">
            <label style="width: 50%">KYC Type:</label>
            <div style="width: 50%">
              <div v-if="isEditing.kyc">
                <select class="form-control" v-model="kyc_type">
                  <option value="aadhar">Aadhaar</option>
                  <option value="pan">Pan Card</option>
                </select>
              </div>
              <div v-else>
                <strong>{{
                  kyc_type === "aadhar" ? "Aadhaar" : "Pan "
                }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- Bank Details -->
        <div
          class="d-flex justify-content-between align-items-center mt-3 mb-2"
        >
          <span class="fw-bold fs-5">BANK Details</span>
          <button
            v-if="!isEditing.bank"
            style="width: 100px"
            :disabled="isEditing.basic || isEditing.kyc"
            class="btn btn-outline-warning btn-md"
            @click="isEditing.bank = true"
          >
            <span class="mdi mdi-pencil"></span>
            Edit
          </button>
          <button
            :disabled="isEditing.basic || isEditing.kyc"
            @click="updateBank()"
            v-if="isEditing.bank"
            class="btn btn-warning btn-md"
          >
            <div
              class="spinner-border spinner-border-sm text-white"
              role="status"
              v-if="loading"
            ></div>
            <div v-else>Save</div>
          </button>
        </div>
        <div class="p-3 text-start" style="background-color: #f7f7f7">
          <div class="mb-2 d-flex justify-content-between align-center">
            <label style="width: 50%">Bank Name:</label>
            <div style="width: 50%">
              <div v-if="isEditing.bank">
                <input
                  v-model="bankDetails.bank_name"
                  @input="v$.bankDetails.bank_name.$touch()"
                  type="text"
                  id="bank_name"
                  class="form-control"
                  placeholder="Enter Bank Name"
                  required
                />
                <div class="error-message">
                  <span v-if="v$.bankDetails.bank_name.$errors.length">
                    {{ v$.bankDetails.bank_name.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div v-else>
                <strong>{{ bankDetails.bank_name }}</strong>
              </div>
            </div>
          </div>
          <div class="mb-2 d-flex justify-content-between align-center">
            <label style="width: 50%">Account Number:</label>
            <div class="text-start" style="width: 50%">
              <div v-if="isEditing.bank">
                <input
                  v-model="bankDetails.acc_number"
                  @input="v$.bankDetails.acc_number.$touch()"
                  type="text"
                  id="acc_num"
                  class="form-control"
                  placeholder="Enter Account Number"
                  required
                />
                <div class="error-message">
                  <span v-if="v$.bankDetails.acc_number.$errors.length">
                    {{ v$.bankDetails.acc_number.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div v-else>
                <strong>{{ bankDetails.acc_number }}</strong>
              </div>
            </div>
          </div>
          <div class="mb-2 d-flex justify-content-between align-center">
            <label style="width: 50%">IFSC CODE:</label>
            <div style="width: 50%">
              <div v-if="isEditing.bank">
                <input
                  v-model="bankDetails.ifsc_code"
                  @input="v$.bankDetails.ifsc_code.$touch()"
                  type="text"
                  id="ifsc"
                  class="form-control"
                  placeholder="Enter IFSC Code"
                  required
                />
                <div class="error-message">
                  <span v-if="v$.bankDetails.ifsc_code.$errors.length">
                    {{ v$.bankDetails.ifsc_code.$errors[0].$message }}
                  </span>
                </div>
              </div>
              <div v-else>
                <strong>{{ bankDetails.ifsc_code }}</strong>
              </div>
            </div>
          </div>
        </div>

        <!-- Confirm Button -->
        <button
          @click="
            operatorOverview = false;
            busOverview = false;
            addMoreBus = true;
            currentStep = 2;
            maxCurrentStep = 2;
          "
          class="btn btn-warning w-100 mt-4 d-flex align-center justify-content-center"
        >
          Confirm & Continue <i class="ri-arrow-right-line"></i>
        </button>
      </div>
      <div
        class="container"
        v-if="currentStep === 3 && busOverview && !addMoreBus"
      >
        <h4 class="mb-3">Review & Submit</h4>
        <p class="text-muted">
          Review all the information before submitting the bus onboarding form.
        </p>

        <div class="accordion" id="reviewAccordion">
          <div class="accordion-item">
            <h2 class="accordion-header" id="headingBus">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseBus"
              >
                <i class="ri-bus-line"></i> Bus Details
              </button>
            </h2>
            <div
              id="collapseBus"
              class="accordion-collapse collapse show"
              data-bs-parent="#reviewAccordion"
            >
              <div class="accordion-body">
                <form id="busForm" @submit.prevent="updateBusDetails()">
                  <div class="row text-start">
                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Travels Name</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.travelsName"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.travelsName.$errors.length"
                          >
                            {{
                              v$.busBasicDetails.travelsName.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Bus Type</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.busType"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.busType.$errors.length"
                          >
                            {{ v$.busBasicDetails.busType.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Bus Color</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.busColor"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.busColor.$errors.length"
                          >
                            {{
                              v$.busBasicDetails.busColor.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Bus Make</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.busMake"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.busMake.$errors.length"
                          >
                            {{ v$.busBasicDetails.busMake.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Base Location</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.baseLocation"
                        />
                        <div class="error-message">
                          <span
                            v-if="
                              v$.busBasicDetails.baseLocation.$errors.length
                            "
                          >
                            {{
                              v$.busBasicDetails.baseLocation.$errors[0]
                                .$message
                            }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-2">
                        <label class="form-label">Registration Number</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.busRegNo"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.busRegNo.$errors.length"
                          >
                            {{
                              v$.busBasicDetails.busRegNo.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Permit Type</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.permitType"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.permitType.$errors.length"
                          >
                            {{
                              v$.busBasicDetails.permitType.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Bus Capacity</label>
                        <input
                          type="number"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.busCapacity"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.busCapacity.$errors.length"
                          >
                            {{
                              v$.busBasicDetails.busCapacity.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Bus District</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.busDistrict"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.busDistrict.$errors.length"
                          >
                            {{
                              v$.busBasicDetails.busDistrict.$errors[0].$message
                            }}
                          </span>
                        </div>
                      </div>
                      <div class="mb-2">
                        <label class="form-label">Pincode</label>
                        <input
                          type="text"
                          class="form-control"
                          :disabled="!isBusEditing"
                          v-model="busBasicDetails.pincode"
                        />
                        <div class="error-message">
                          <span
                            v-if="v$.busBasicDetails.pincode.$errors.length"
                          >
                            {{ v$.busBasicDetails.pincode.$errors[0].$message }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-3 text-end">
                    <button
                      class="btn btn-warning text-white border-0"
                      type="submit"
                      :disabled="isBusLoading"
                      :class="[
                        'btn',
                        {
                          'btn-soft-warning': !isBusLoading,
                          'btn-grey': isBusLoading,
                        },
                        F,
                      ]"
                    >
                      <div
                        v-if="isBusLoading"
                        class="spinner-border spinner-border-sm text-white"
                        role="status"
                      ></div>
                      <div v-else class="text-white">
                        {{ isBusEditing ? "Save" : "Edit" }}
                      </div>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingRoute">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseRoute"
              >
                <i class="ri-map-pin-line"></i> Route Details
              </button>
            </h2>
            <div
              id="collapseRoute"
              class="accordion-collapse collapse show"
              data-bs-parent="#reviewAccordion"
            >
              <div class="accordion-body">
                <div class="row g-3" style="text-align: left">
                  <div class="col-lg-6 input-container">
                    <label for="from" class="form-label fw-bold"
                      >From<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      id="from"
                      v-model="routeDetails.from"
                      :disabled="!isRouteEditing"
                      @input="v$.routeDetails.from.$touch()"
                      class="form-control"
                      placeholder="Starting Point"
                      required
                    />
                    <div class="error-message">
                      <span v-if="v$.routeDetails.from.$errors.length">
                        {{ v$.routeDetails.from.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="via" class="form-label fw-bold"
                        >via<span class="fw-normal">(optional)</span></label
                      >
                      <input
                        type="text"
                        v-model="routeDetails.via"
                        id="via"
                        :disabled="!isRouteEditing"
                        class="form-control"
                        placeholder="important stops en route"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="to" class="form-label fw-bold"
                        >To <span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        v-model="routeDetails.to"
                        @input="v$.routeDetails.to.$touch()"
                        id="to"
                        class="form-control"
                        :disabled="!isRouteEditing"
                        placeholder="Destination Point"
                        required
                      />
                    </div>
                    <div class="error-message">
                      <span v-if="v$.routeDetails.to.$errors.length">
                        {{ v$.routeDetails.to.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="to" class="form-label fw-bold"
                        >Total Number of Stops<span style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        v-model="routeDetails.noOfStops"
                        @input="v$.routeDetails.noOfStops.$touch()"
                        type="text"
                        id="op_name"
                        class="form-control"
                        placeholder="eg: 10"
                        required
                      />
                    </div>
                    <div class="error-message">
                      <span v-if="v$.routeDetails.noOfStops.$errors.length">
                        {{ v$.routeDetails.noOfStops.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="total_km" class="form-label fw-bold"
                        >Total KMs Covered
                        <span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        v-model="routeDetails.totalKm"
                        @input="v$.routeDetails.totalKm.$touch()"
                        id="total_km"
                        class="form-control"
                        maxlength="10"
                        placeholder="eg, 250"
                        :disabled="!isRouteEditing"
                        required
                      />
                    </div>
                    <div class="error-message">
                      <span v-if="v$.routeDetails.totalKm.$errors.length">
                        {{ v$.routeDetails.totalKm.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="min_fare" class="form-label fw-bold"
                        >Minimum Fare($)<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        v-model="routeDetails.minimumFare"
                        @input="v$.routeDetails.minimumFare.$touch()"
                        id="min_fare"
                        class="form-control"
                        :disabled="!isRouteEditing"
                        placeholder="Lowest Fare Amount"
                        required
                      />
                    </div>
                    <div class="error-message">
                      <span v-if="v$.routeDetails.minimumFare.$errors.length">
                        {{ v$.routeDetails.minimumFare.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="max_fare" class="form-label fw-bold"
                        >Maximum Fare<span style="color: red">*</span></label
                      >
                      <input
                        type="text"
                        v-model="routeDetails.maximumFare"
                        @input="v$.routeDetails.maximumFare.$touch()"
                        id="max_fare"
                        class="form-control"
                        maxlength="10"
                        :disabled="!isRouteEditing"
                        placeholder="Highest Fare Amount"
                        required
                      />
                    </div>
                    <div class="error-message">
                      <span v-if="v$.routeDetails.maximumFare.$errors.length">
                        {{ v$.routeDetails.maximumFare.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                  <div class="col-lg-6 input-container">
                    <div>
                      <label for="lug_fare" class="form-label fw-bold"
                        >Luggage Fare per Unit<span style="color: red"
                          >*</span
                        ></label
                      >
                      <input
                        type="text"
                        v-model="routeDetails.luggageFare"
                        @input="v$.routeDetails.luggageFare.$touch()"
                        id="lug_fare"
                        class="form-control"
                        :disabled="!isRouteEditing"
                        placeholder="Charge per kg or piece"
                        required
                      />
                    </div>
                    <div class="error-message">
                      <span v-if="v$.routeDetails.luggageFare.$errors.length">
                        {{ v$.routeDetails.luggageFare.$errors[0].$message }}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="mt-3 text-end">
                  <button
                    class="btn btn-warning text-white border-0"
                    type="submit"
                    @click="updateRouteDetails"
                    :disabled="isRouteLoading"
                    :class="[
                      'btn',
                      {
                        'btn-soft-warning': !isRouteLoading,
                        'btn-grey': isRouteLoading,
                      },
                      F,
                    ]"
                  >
                    <div
                      v-if="isRouteLoading"
                      class="spinner-border spinner-border-sm text-white"
                      role="status"
                    ></div>
                    <div v-else class="text-white">
                      {{ isRouteEditing ? "Save" : "Edit" }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingStops">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseStops"
              >
                <i class="ri-map-pin-line"></i> Stops
              </button>
            </h2>
            <div
              id="collapseStops"
              class="accordion-collapse collapse show"
              data-bs-parent="#reviewAccordion"
            >
              <div class="accordion-body">
                <table
                  style="
                    width: 100%;
                    border-collapse: collapse;
                    text-align: left;
                  "
                >
                  <thead>
                    <tr style="border-bottom: 1px solid #ccc">
                      <th class="p-3">Stop</th>
                      <th>Stop Name</th>
                      <th>ETA from Starting Point Minutes</th>
                      <th>Distance from Starting Point KMs</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(stop, i) in order_of_stops || []"
                      :key="i"
                      style="border-bottom: 1px solid #eee; height: 50px"
                      class="p-3"
                    >
                      <td>{{ `Stop ${i}` }}</td>

                      <!-- Stop Name -->
                      <td>
                        <div v-if="editingRowIndex === i">
                          <input
                            v-model="stop.stop"
                            :class="{
                              'error-border':
                                v$.order_of_stops?.$each?.[i]?.stop?.$error,
                            }"
                          />
                          <div
                            v-if="v$.order_of_stops?.$each?.[i]?.stop?.$error"
                            class="error-text"
                          >
                            Stop Name is required
                          </div>
                        </div>
                        <div v-else>{{ stop.stop || "Stop Name" }}</div>
                      </td>

                      <!-- ETA -->
                      <td>
                        <div v-if="editingRowIndex === i">
                          <input
                            v-model="stop.time"
                            :class="{
                              'error-border':
                                v$.order_of_stops?.$each?.[i]?.time?.$error,
                            }"
                          />
                          <div
                            v-if="v$.order_of_stops?.$each?.[i]?.time?.$error"
                            class="error-text"
                          >
                            Valid ETA required
                          </div>
                        </div>
                        <div v-else>
                          {{
                            stop.time !== undefined && stop.time !== null
                              ? stop.time
                              : "Add ETA"
                          }}
                        </div>
                      </td>

                      <!-- Distance -->
                      <td>
                        <div v-if="editingRowIndex === i">
                          <input
                            v-model="stop.distance"
                            :class="{
                              'error-border':
                                v$.order_of_stops?.$each?.[i]?.distance?.$error,
                            }"
                          />
                          <div
                            v-if="
                              v$.order_of_stops?.$each?.[i]?.distance?.$error
                            "
                            class="error-text"
                          >
                            Valid Distance required
                          </div>
                        </div>
                        <div v-else>
                          {{
                            stop.distance !== undefined &&
                            stop.distance !== null
                              ? stop.distance
                              : "Add Distance"
                          }}
                        </div>
                      </td>

                      <!-- Actions -->
                      <td class="text-center">
                        <i
                          v-if="editingRowIndex !== i"
                          class="ri-pencil-line fs-5"
                          style="cursor: pointer"
                          @click="editingRowIndex = i"
                        ></i>

                        <i
                          v-else
                          class="ri-check-line text-green-600 fs-5"
                          style="cursor: pointer"
                          @click="editingRowIndex = null"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="mt-3 text-end">
                  <button
                    class="btn btn-warning text-white border-0"
                    type="submit"
                    @click="updateStopDetails"
                    :disabled="loading"
                    :class="[
                      'btn',
                      {
                        'btn-soft-warning': !loading,
                        'btn-grey': loading,
                      },
                    ]"
                  >
                    <div
                      v-if="loading"
                      class="spinner-border spinner-border-sm text-white"
                      role="status"
                    ></div>
                    <div v-else class="text-white">
                      {{ loading ? "" : "Save" }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingFare">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseFare"
              >
                <i class="ri-money-cny-circle-line"></i>
                Fare Details
              </button>
            </h2>
            <div
              id="collapseFare"
              class="accordion-collapse collapse show"
              data-bs-parent="#reviewAccordion"
            >
              <div class="accordion-body">
                <table class="fare-table">
                  <thead>
                    <tr>
                      <th>From / To</th>
                      <th v-for="to in order_of_stops" :key="to.stop">
                        {{ to.stop }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(from, i) in order_of_stops" :key="from.stop">
                      <td>{{ from.stop }}</td>
                      <td v-for="(to, j) in order_of_stops" :key="to.stop">
                        <span v-if="j <= i">-</span>
                        <span v-else>
                          <span
                            v-if="isFareTableEditing"
                            class="fare-input-wrapper"
                          >
                            <input
                              type="number"
                              v-model.number="getFareObject(from, to).fare"
                              min="0"
                              class="fare-input"
                            />
                          </span>
                          <span v-else>
                            ₹{{ getFareObject(from, to)?.fare ?? "-" }}
                          </span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-end">
                  <button
                    @click="editFareTable"
                    style="
                      height: 40px;
                      width: 140px;
                      background-color: #eab308;
                      color: white;
                      border: none;
                    "
                    class="d-flex align-center justify-content-center pt-2 rounded"
                    :disabled="loading"
                    :class="[
                      'btn',
                      {
                        'btn-soft-warning': !loading,
                        'btn-grey': loading,
                      },
                    ]"
                  >
                    <div
                      v-if="loading"
                      class="spinner-border spinner-border-sm text-white"
                      role="status"
                    ></div>
                    <div v-else class="text-white">
                      {{ isFareTableEditing ? "Save" : "Edit" }}
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingTime">
              <button
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTime"
              >
                <i class="ri-calendar-line"></i>
                Time Table
              </button>
            </h2>
            <div
              id="collapseTime"
              class="accordion-collapse collapse show"
              data-bs-parent="#reviewAccordion"
            >
              <div class="accordion-body">
                <div class="timetable-wrapper">
                  <div
                    class="d-flex justify-content-between align-items-center mb-2"
                  >
                    <h5 class="mb-0">Bus Route Timetable</h5>
                    <div>
                      <button
                        v-if="!isTimeTableEditing"
                        class="btn btn-outline-primary btn-sm"
                        @click="startEditing"
                      >
                        Edit
                      </button>
                      <div v-else>
                        <button
                          class="btn btn-success btn-sm me-2"
                          @click="saveChanges"
                        >
                          Save
                        </button>
                        <button
                          class="btn btn-secondary btn-sm"
                          @click="cancelChanges"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="table-responsive small-table">
                    <table class="table table-sm table-bordered table-striped">
                      <thead class="table-light">
                        <tr>
                          <th>Type</th>
                          <th>ID</th>
                          <th>Trip Details</th>
                          <th v-for="stop in uniqueStops" :key="stop">
                            {{ stop }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(timetable, index) in displayTimetables"
                          :key="index"
                        >
                          <td>{{ timetable.trip_type }}</td>
                          <td>{{ timetable.trip_id }}</td>
                          <td>Trip {{ index + 1 }}</td>

                          <td v-for="stop in uniqueStops" :key="stop">
                            <input
                              v-if="isTimeTableEditing"
                              type="time"
                              class="form-control form-control-sm"
                              v-model="timetable.time_table_obj[stop]"
                            />
                            <span v-else>{{
                              timetable.time_table_obj[stop] || "--"
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4 p-3 bg-light border rounded">
          <strong>Submission Notes</strong>
          <p class="text-muted mb-0">
            By submitting this form, you confirm that all information provided
            is accurate and that you have permission to operate this bus
            service.
          </p>
        </div>

        <div class="d-flex justify-content-end mt-4 mb-2">
          <button
            class="btn btn-primary"
            :disabled="loading"
            :class="[
              'btn',
              {
                'btn-soft-warning': !loading,
                'btn-grey': loading,
              },
            ]"
            @click="submitBusDetails"
          >
            <div
              v-if="loading"
              class="spinner-border spinner-border-sm text-white"
              role="status"
            ></div>
            <div v-else class="text-white">
              Submit <i class="ri-arrow-right-line mx-1"></i>
            </div>
          </button>
        </div>
      </div>
      <!-- Add More Buses -->
      <div v-if="addMoreBus && currentStep === 2">
        <div class="container py-5" style="max-width: 700px">
          <!-- Title -->
          <h5 class="fw-bold">Buses Overview</h5>
          <p class="text-muted">Total {{ totalNoOfBuses.length }} Buses</p>

          <div
            v-for="(bus, index) in totalNoOfBuses"
            :key="index"
            class="d-flex justify-content-between align-items-center border rounded px-3 py-2 mb-2 bg-light"
          >
            <span class="text-uppercase">
              {{ bus.reg_no }} • {{ bus.travels_name }} •
              <strong>{{ bus?.route_details[0]?.source }}</strong> to
              <strong>{{ bus?.route_details[0]?.destination }}</strong>
            </span>
            <div>
              <button
                @click="viewQR(bus.bus_id,bus.route_details[0]?.route_id)"
                class="btn btn-sm btn-link text-dark"
              >
                <i class="ri-eye-line"></i>
              </button>
              <button
                @click="editBusDetails(bus.bus_id)"
                class="btn btn-sm btn-link text-dark"
              >
                <i class="ri-edit-line"></i>
              </button>
              <button
                @click="deletebus(bus.bus_id)"
                class="btn btn-sm btn-link text-dark"
              >
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>

          <!-- Add Bus Button -->
          <button
            @click="addAnotherBus"
            class="btn btn-outline-dark w-100 mb-4"
          >
            <i class="ri-add-line"></i> Add Bus
          </button>
        </div>
      </div>
      <!-- Add More Routes -->
      <div v-if="addMoreRoute && currentStep === 3">
        <div class="container py-5" style="max-width: 700px">
          <!-- Title -->
          <!-- <h5 class="fw-bold mb-2">Routes Overview</h5> -->

          <div v-for="(bus, index) in totalNoOfBuses" :key="index" class="my-2">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <strong class="text-uppercase text-start"
                >{{ bus.reg_no }} • {{ bus.travels_name }}
              </strong>
              <button
                @click="addAnotherRoute(bus.bus_id)"
                class="btn btn-sm text-dark"
              >
                <i class="ri-add-line"></i>
              </button>
            </div>

            <ul v-if="bus?.route_details.length">
              <li
                v-for="(route, index) in bus?.route_details"
                :key="index"
                class="d-flex align-items-center justify-content-between bg-light p-1 rounded mt-2"
              >
                <div class="text-capitalize">
                  <strong>{{ route.source }}</strong> to
                  <strong>{{ route.destination }}</strong> via
                  <strong>{{ route.via_locations }}</strong>
                </div>

                <div>
                  <button
                    @click="editBusDetails(bus.bus_id, route.route_id)"
                    class="btn btn-sm btn-link text-dark"
                  >
                    <i class="ri-edit-line"></i>
                  </button>
                  <button
                    @click="deletebus(bus.bus_id, route.route_id)"
                    class="btn btn-sm btn-link text-dark"
                  >
                    <i class="ri-delete-bin-line"></i>
                  </button>
                </div>
              </li>
            </ul>
            <span v-else class="text-muted text-start mt-2"
              >No routes added yet.</span
            >
          </div>

          <!-- Next Step Button -->
          <button
            class="btn btn-warning fw-bold w-100"
            @click="goToStaffAddition"
            :disabled="loading || !bus_id"
            :class="[
              'btn',
              {
                'btn-soft-warning': !loading,
                'btn-grey': loading,
                'btn-grey': !bus_id,
              },
            ]"
          >
            <div
              v-if="loading"
              class="spinner-border spinner-border-sm text-white"
              role="status"
            ></div>
            <div v-else class="text-white">Next Step - Staff Addition</div>
          </button>
        </div>
      </div>
    </div>

    <ToastNotification ref="toast" />
    <DeleteDialog
      title="Delete Image ?"
      message="Are you sure you want to delete the bus image"
      ref="deleteDialog"
      @confirm="deleteImage"
    />

    <Loader v-if="loaderLoading" />
  </div>
</template>

<script>
import payIcon from "@/assets/pay_ic.png";
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  helpers,
} from "@vuelidate/validators";
import { createKyc, updateKyc } from "@/apis/kycapis";
import { addOperator, updateOperator, getOperatorById } from "@/apis/operator";
import ToastNotification from "@/components/dialog/ToastNotification.vue";
import { mapActions, mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import { createBank, updateBank } from "@/apis/bank";
import Loader from "@/components/loader/loader.vue";
import {
  createBus,
  uploadBusImage,
  updateBusImage,
  deleteBusImage,
  getTripTimeTable,
  updateTripTimeTable,
  getBusById,
  updateBus,
  deleteBus,
} from "@/apis/busdetailsapis";
import { createTripSchedule, deleteTripById, editTripById } from "@/apis/trip";
import { addRoute, updateRoute } from "@/apis/routeapis";
import { createStaff, updateStaff, deleteStaff } from "@/apis/staffapis";
import { patchFareTable, getFareTable } from "@/apis/routeapis";
import DeleteDialog from "@/components/dialog/DeleteDialog.vue";
import QrScanner from "@/components/qr/QrScanner.vue";
import html2canvas from "html2canvas";

import { createCity } from "@/apis/city";
import { getAllCities } from "@/apis/city";

const atLeastOne = helpers.withMessage(
  "At least one bus must be linked",
  (value) => Array.isArray(value) && value.length > 0
);

export default {
  name: "AppAddOperator",
  components: {
    ToastNotification,
    Loader,
    DeleteDialog,
    QrScanner,
  },
  data() {
    return {
      payIcon,
      loading: false,
      loaderLoading: false,

      availableCities: [],
      selectedDistrict: "",
      showCustomDistrict: false,

      tripCount: null,

      type: "operator",

      v$: null,

      currentStep: 1,
      maxCurrentStep: 1,
      page_no: 1,
      max_step: 1,

      editMode: false,
      fares: [],

      operator_id: null,
      kyc_id: null,
      bank_id: null,
      bus_id: null,
      route_id: null,
      staff_id: null,

      kyc_value: null,
      kyc_type: "aadhar",

      mainSteps: [
        { label: "Operator Details", color: "#ffc107" },
        { label: "Bus Details", color: "#ffc107" },
        { label: "Route Details", color: "#ffc107" },
        { label: "Staff Details", color: "#ffc107" },
      ],

      operatorSubtitle: ["Basic Details", "Kyc Details", "Bank Details"],
      busSubtitle: ["Bus Details", "Bus Images", "Bus QR"],
      routeSubtitle: [
        "Route Details",
        "Stop Table",
        "Fare Table",
        "Trip Table",
        "Time Table",
      ],
      staffSubtitle: ["Staff Details"],
      subtitle: [],

      // Toggle overview page
      operatorOverview: false,
      busOverview: false,

      // Toggle edit mode
      isEditing: {
        basic: false,
        kyc: false,
        bank: false,
      },

      addMoreRoute: false,

      isLoading: {
        basic: false,
        kyc: false,
        bank: false,
      },

      isFareTableEditing: false,

      operatorDetails: {
        name: "",
        email: "",
        phone_number: "",
        referral_code: "",
      },

      imageTypes: ["primary", "back", "cover", "inside", "other"],
      hoverIndex: null,

      staffdetails: {
        name: "",
        role: "",
        phone_number: "",
        linked_buses: [],
        status: false,
      },

      staffData: [],

      kycDetails: {
        aadhar_no: "",
        pan_no: "",
      },

      bankDetails: {
        bank_name: "",
        acc_number: "",
        ifsc_code: "",
        cnf_acc_no: "",
      },

      busBasicDetails: {
        travelsName: "",
        busRegNo: "",
        busType: "",
        permitType: "",
        busColor: "",
        busCapacity: "",
        busMake: "",
        busDistrict: "",
        baseLocation: "",
        pincode: "",
      },

      isBusEditing: false,
      isBusLoading: false,

      isRouteEditing: false,
      isRouteLoading: false,

      isStopLoading: false,

      routeDetails: {
        from: "",
        via: "",
        to: "",
        noOfStops: null,
        totalKm: null,
        minimumFare: null,
        maximumFare: null,
        luggageFare: null,
        total_duration: "",
      },

      //Trip Table
      editingRowIndex: null,
      trips: [],

      total_trips: 0,
      total_uptrips: 0,
      total_downtrips: 0,

      order_of_stops: [],

      images: {
        busImages: [],
        rcFrontImage: {
          id: null,
          file: null,
        },
        rcBackImage: {
          id: null,
          file: null,
        },
      },

      timetables: [],
      displayTimetables: [],
      isTimeTableEditing: false,
      originalTimetables: null,

      addMoreBus: false,

      totalNoOfBuses: [],

      isOverallEdit: null,
    };
  },
  watch: {
    currentStep(newVal) {
      if (newVal === 1) {
        this.subtitle = this.operatorSubtitle;
      } else if (newVal === 2) {
        this.subtitle = this.busSubtitle;
      } else if (newVal === 3) {
        this.subtitle = this.routeSubtitle;
      } else if (newVal === 4) {
        this.subtitle = this.staffSubtitle;
      } else {
        this.subtitle = [];
      }
    },
  },

  methods: {
    ...mapActions(useUserStore, ["getEditData", "storeEditData"]),

    onDistrictChange() {
      if (this.selectedDistrict === "other") {
        this.showCustomDistrict = true;
        this.busBasicDetails.busDistrict = "";
      } else {
        this.showCustomDistrict = false;
        this.busBasicDetails.busDistrict = this.selectedDistrict;
      }
      this.v$.busBasicDetails.busDistrict.$touch();
    },

    async createCity(city) {
      const response = await createCity(city);

      if (response.status || response.success) {
        this.availableCities.push(city);
      } else {
        this.$refs.toast.showToast(response.message, "error");
      }
    },

    async fetchCityList() {
      const response = await getAllCities({});
      if (response) {
        this.availableCities = response.data.map((item) => item.city_name);
      }
    },

    final() {
      this.$refs.toast.showToast("Operator Onboared Successfully", "success");
      this.$router.push("/operators");
    },

    handleStepClick(stepNumber) {
      if (this.isOverallEdit)
        this.page_no = this.max_step = this.subtitle.length;

      if (stepNumber <= this.max_step) {
        this.page_no = stepNumber;
      }
    },

    redirecting(step) {
      const stepIndex =
        this.mainSteps.findIndex((s) => s.label === step.label) + 1;

      if (!this.isOverallEdit && stepIndex > this.maxCurrentStep) return;

      this.currentStep = stepIndex;
      this.addMoreBus = false;
      this.addMoreRoute = false;
      this.busOverview = false

      if (step.label === "Operator Details" || step.label === "Staff Details") {
        this.page_no = 1;
        this.max_step = 3;
      } else if (step.label === "Bus Details") {
        this.page_no = 1;
        this.max_step = 3;
        this.addMoreBus = true;
      } else if (step.label === "Route Details") {
        this.page_no = 1;
        this.max_step = 6;
        this.addMoreBus = false;
        this.addMoreRoute = true;
      }
    },

    async viewQR(busId,routeId) {
      this.loaderLoading = true;
      this.bus_id = busId;
      await this.getBusDetails(busId,routeId);
      this.addMoreBus = false;
      this.page_no = 3;
      this.currentStep = 2;
      this.loaderLoading = false;
    },

    async downloadQrScanner() {
      const element = this.$refs.qrSection;

      const canvas = await html2canvas(element, {
        useCORS: true,
        scale: 2,
        backgroundColor: "#ffffff",
      });

      const link = document.createElement("a");
      link.download = "qr-ticket.png";
      link.href = canvas.toDataURL("image/png");
      link.click();
    },

    exportTableToCSV() {
      const headers = [
        "Trip Type",
        "Trip ID",
        "Trip Number",
        ...this.uniqueStops,
      ];

      const rows = this.displayTimetables.map((timetable, index) => {
        return [
          timetable.trip_type,
          timetable.trip_id,
          `Trip ${index + 1}`,
          ...this.uniqueStops.map(
            (stop) => timetable.time_table_obj[stop] || "--"
          ),
        ];
      });

      const csvContent = [headers, ...rows]
        .map((row) =>
          row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(",")
        )
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.download = "timetable.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    addAnotherRoute(busId) {
      this.clearBusAndRouteFormDetails();
      this.bus_id = busId;
      this.addMoreRoute = false;
      this.currentStep = 3;
      this.maxCurrentStep = 3;
      this.max_step = 1;
      this.page_no = 1;
    },

    clearBusAndRouteFormDetails() {
      this.v$.$reset();

      this.bus_id = "";
      this.route_id = "";
      this.fares = [];

      this.images.busImages = [];
      this.images.rcBackImage = null;
      this.images.rcFrontImage = null;
      // Clear inputs
      this.selectedDistrict = "";

      this.busBasicDetails = {
        travelsName: "",
        busRegNo: "",
        busType: "",
        permitType: "",
        busColor: "",
        busCapacity: "",
        busMake: "",
        busDistrict: "",
        baseLocation: "",
        pincode: "",
      };

      this.routeDetails = {
        from: "",
        via: "",
        to: "",
        noOfStops: null,
        totalKm: null,
        minimumFare: null,
        maximumFare: null,
        luggageFare: null,
        total_duration: "",
      };

      this.displayTimetables = [];
      this.images = {
        busImages: [],
        rcFrontImage: {
          id: null,
          file: null,
        },
        rcBackImage: {
          id: null,
          file: null,
        },
      };
      this.trips = [];
      this.order_of_stops = [];
    },

    addAnotherBus() {
      this.v$.$reset();

      this.bus_id = "";
      this.route_id = "";
      this.fares = [];

      this.images.busImages = [];
      this.images.rcBackImage = null;
      this.images.rcFrontImage = null;

      this.addMoreBus = false;
      this.currentStep = 2;
      this.maxCurrentStep = 2;
      this.max_step = 1;
      this.page_no = 1;
      this.isOverallEdit = false;

      // Clear inputs

      this.selectedDistrict = "";

      this.busBasicDetails = {
        travelsName: "",
        busRegNo: "",
        busType: "",
        permitType: "",
        busColor: "",
        busCapacity: "",
        busMake: "",
        busDistrict: "",
        baseLocation: "",
        pincode: "",
      };

      this.routeDetails = {
        from: "",
        via: "",
        to: "",
        noOfStops: null,
        totalKm: null,
        minimumFare: null,
        maximumFare: null,
        luggageFare: null,
        total_duration: "",
      };

      this.displayTimetables = [];

      this.images = {
        busImages: [],
        rcFrontImage: {
          id: null,
          file: null,
        },
        rcBackImage: {
          id: null,
          file: null,
        },
      };

      this.trips = [];

      this.order_of_stops = [];
    },

    async deletebus(busID) {
      const response = await deleteBus(busID);
      await this.assignOperatorData();
      if (response.success) {
        this.$refs.toast.showToast("Bus Deleted Successfully", "success");
      } else {
        this.$refs.toast.showToast("Failed to Delete Bus", "error");
      }
    },

    getRoleClass(role) {
      return role.toLowerCase();
    },

    async goToStaffAddition() {
      this.startLoading();
      await this.assignOperatorData();
      this.stopLoading();
      this.addMoreRoute = false;
      this.page_no = 1;
      this.maxCurrentStep = 4;
      this.currentStep = 4;
    },

    async updateStatus(staff) {
      const response = await updateStaff(staff.staff_id, staff);
      if (response.success) {
        this.$refs.toast.showToast("Staff Data Edited Successfully", "success");
      } else {
        this.$refs.toast.showToast("Unexpected  error occured.", "error");
      }
    },

    async deleteStaff(staff) {
      const response = await deleteStaff(staff.staff_id);
      if (response.success) {
        await this.assignOperatorData();
        this.$refs.toast.showToast(
          "Staff Data Deleted Successfully",
          "success"
        );
      } else {
        this.$refs.toast.showToast("Unexpected  error occured.", "error");
      }
    },

    async submitStaff() {
      if (this.staff_id) {
        await this.updateStatus({
          staff_id: this.staff_id,
          staff: this.staffdetails,
        });
        await this.assignOperatorData();
      } else {
        for (const busId of this.staffdetails.linked_buses) {
          this.loading = true;
          try {
            const response = await createStaff(busId, this.staffdetails);
            if (response.success) {
              this.$refs.toast.showToast(
                "Staff Added  Successfully",
                "success"
              );
            }
          } catch (error) {
            this.$refs.toast.showToast("Failed to Add Staff", "error");
          }
          this.loading = false;
        }
      }

      await this.assignOperatorData();

      const modalElement = this.$refs.addStaffModalRef;
      const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
      modalInstance.hide();

      this.staff_id = "";
      this.staffdetails = {
        name: "",
        phone_number: "",
        role: "",
        linked_buses: [],
      };
    },

    editStaff(index) {
      const selectedStaff = this.staffData[index];
      this.staff_id = selectedStaff.staff_id;

      const linkedBuses = selectedStaff.bus_details
        .filter((bus) => bus.bus_id)
        .map((bus) => bus.bus_id);

      this.staffdetails = {
        name: selectedStaff.name || "",
        phone_number: selectedStaff.phone_number || "",
        role: selectedStaff.role || "",
        linked_buses: linkedBuses,
      };

      const modalElement = this.$refs.addStaffModalRef;

      let modalInstance = window.bootstrap.Modal.getInstance(modalElement);
      if (!modalInstance) {
        modalInstance = new window.bootstrap.Modal(modalElement);
      }

      modalInstance.show();
    },

    getFareObject(from, to) {
      const fromStop = (
        typeof from === "object" ? from.stop : from
      ).toLowerCase();
      const toStop = (typeof to === "object" ? to.stop : to).toLowerCase();

      let fareObj = this.fares.find((entry) => {
        const stop1 = entry.stop1.toLowerCase();
        const stop2 = entry.stop2.toLowerCase();

        return (
          (stop1 === fromStop && stop2 === toStop) ||
          (stop1 === toStop && stop2 === fromStop)
        );
      });

      if (!fareObj && this.isFareTableEditing && fromStop !== toStop) {
        fareObj = {
          stop1: fromStop,
          stop2: toStop,
          fare: 0,
          bus_stop_id: null,
        };
        this.fares.push(fareObj);
      }

      return fareObj;
    },

    addTrip() {
      this.trips.push({
        trip_type: this.trips.length % 2 === 0 ? "up" : "down",
        trip_id: null,
        trip_start_time: "",
        trip_number: this.trips.length + 1,
        editable: true,
      });
    },

    async toggleEditTrip(tripID, index) {
      let trip = this.trips[index];

      if (tripID.trip_id) {
        if (trip.editable) {
          this.loaderLoading = true;

          const response = await editTripById(tripID.trip_id, trip);
          if (response.success) {
            this.loaderLoading = false;

            trip.editable = false;
            this.$refs.toast.showToast("Trip Updated Successfully", "success");
          } else {
            this.$refs.toast.showToast("Failed To Update Trip", "error");
          }
        } else {
          trip.editable = true;
        }
      } else {
        trip.editable = !trip.editable;
      }
      this.loaderLoading = false;
    },
    async removeTrip(trip, index) {
      this.loaderLoading = true;
      let res = null;
      if (trip.trip_id) {
        res = await deleteTripById(trip.trip_id);
      } else {
        this.loaderLoading = false;
        this.trips.splice(index, 1);
        this.tripCount = this.trips.length;
        return { res: { success: true } };
      }
      if (res.success) {
        await this.assignOperatorData();
        this.$refs.toast.showToast("Trip Deleted Successfully", "success");
      } else {
        this.$refs.toast.showToast("Failed to Delete Trip", "error");
      }

      this.loaderLoading = false;
    },
    generateOrderOfStops() {
      const { from, to, noOfStops } = this.routeDetails;

      if (!from || !to || !noOfStops) {
        console.warn(
          "Cannot generate order_of_stops: incomplete routeDetails",
          this.routeDetails
        );
        return;
      }

      const stopsCount = Number(noOfStops);
      if (isNaN(stopsCount)) {
        console.warn("Invalid number of stops");
        return;
      }

      this.order_of_stops = [];

      this.order_of_stops.push({
        stop: from,
        time: 0,
        distance: 0,
        stop_number: 0,
      });

      for (let i = 1; i <= stopsCount; i++) {
        this.order_of_stops.push({
          stop: "",
          time: 0,
          distance: 0,
          stop_number: i,
        });
      }

      this.order_of_stops.push({
        stop: to,
        time: 0,
        distance: 0,
        stop_number: stopsCount + 1,
      });
    },
    async getBusDetails(busID, routeID = null) {
      const response = await getBusById(busID);

      if (response.success) {
        const {
          base_location,
          base_pin_code,
          bus_type,
          capacity,
          make,
          color,
          district,
          permit_type,
          reg_no,
          route_details,
          trips_by_route,
          stop_details,
          image_url,
          travels_name,
        } = response.data;

        this.images.busImages = [];

        image_url.forEach((eachImg) => {
          if (eachImg.image_type === "rc-book-front") {
            this.previrwRcFront = eachImg.image_url;
            this.images.rcFrontImage.file = eachImg.image_url;
            this.images.rcFrontImage.id = eachImg.image_id;
          } else if (eachImg.image_type === "rc-book-back") {
            this.previewRcBack = eachImg.image_url;
            this.images.rcBackImage.file = eachImg.image_url;
            this.images.rcBackImage.id = eachImg.image_id;
          } else {
            this.images.busImages.push(eachImg);
          }
        });

        this.busBasicDetails = {
          travelsName: travels_name,
          busRegNo: reg_no,
          busType: bus_type,
          permitType: permit_type,
          busColor: color,
          busCapacity: capacity,
          busMake: make,
          busDistrict: district,
          baseLocation: base_location,
          pincode: base_pin_code,
        };

        this.selectedDistrict = district.toLowerCase();

        if (routeID) {
          const route_details_filtered = route_details.filter(
            (route) => route.route_id === routeID
          );
          if (route_details_filtered.length > 0) {
            const [route] = route_details_filtered;
            const {
              destination,
              luggage_fare_per_unit,
              max_fare,
              min_fare,
              order_of_stops,
              route_id,
              source,
              total_distance,
              total_duration,
              total_stops,
              via_locations,
            } = route;
            this.route_id = route_id;

            this.routeDetails = {
              from: source,
              via: via_locations,
              to: destination,
              noOfStops: total_stops,
              totalKm: total_distance,
              minimumFare: min_fare,
              maximumFare: max_fare,
              luggageFare: luggage_fare_per_unit,
              total_duration: total_duration,
            };

            if (order_of_stops.length > 0) {
              this.order_of_stops = order_of_stops;
            } else {
              this.generateOrderOfStops();
            }

              if (stop_details && stop_details[routeID]?.length > 0) {
                this.fares = stop_details[routeID];
              } else {
                this.fares = [];
              }

              console.log(trips_by_route,"didj")

            if (trips_by_route) {
              this.total_trips = trips_by_route.total_trips;
              this.trips = trips_by_route[routeID] || [];
            } else {
              this.trips = [];
            }

            await this.getTripTimeTable(routeID);
          }
        }
      }

      return response;
    },

    startLoading() {
      this.loading = true;
    },

    stopLoading() {
      this.loading = false;
    },

    clearErrorMsg() {
      this.msgTxt = "";
      this.msgType = "";
    },

    assignErrorMsg(msg, type) {
      this.msgTxt = msg;
      this.msgType = type;
    },

    nextPage() {
      this.page_no++;
      this.max_step++;
    },

    openDeleteDialog(img, index) {
      this.$refs.deleteDialog.openDialog(img.image_id, index);
    },

    clearKycDetails() {
      if (this.kyc_type === "aadhar") {
        this.kycDetails.pan_no = "";
      } else if (this.kyc_type === "pan") {
        this.kycDetails.aadhar_no = "";
      }
    },

    async validate() {
      this.startLoading();

      if (this.currentStep === 1) {
        switch (this.page_no) {
          case 1: {
            let res = null;

            if (this.operator_id) {
              res = await this.updateOperator();
            } else {
              res = await this.addOperator();
            }

            if (res.success && !this.isEditing.basic) {
              this.nextPage();
            }
            break;
          }
          case 2: {
            this.clearKycDetails();

            const isAadharValid =
              this.kyc_type === "aadhar" &&
              !this.v$.kycDetails.aadhar_no.$invalid;
            const isPanValid =
              this.kyc_type === "pan" && !this.v$.kycDetails.pan_no.$invalid;

            try {
              if (isAadharValid || isPanValid) {
                if (this.kyc_id) {
                  await this.updateKycDetails();
                } else {
                  await this.addKycDetails();
                }
              }
            } catch (error) {
              this.$refs.toast.showToast("Failed to save KYC details", "error");
            } finally {
              this.stopLoading();
            }
            break;
          }
          case 3: {
            let res = null;
            try {
              res = this.bank_id
                ? await this.updateBank()
                : await this.createBank();

              if (res.success && !this.isEditing.basic) {
                this.operatorOverview = true;
              }
            } catch (error) {
              this.$refs.toast.showToast(
                "Something went wrong while saving bank details",
                "error"
              );
            } finally {
              this.stopLoading();
            }
            break;
          }
        }
      } else if (this.currentStep === 2) {
        switch (this.page_no) {
          case 1: {
            const district = this.busBasicDetails.busDistrict?.trim();
            const isNewDistrict =
              district && !this.availableCities.includes(district);

            if (isNewDistrict) {
              await this.createCity(district);
            }

            let res = null;
            if (this.bus_id) {
              this.isBusEditing = true;
              res = await this.updateBusDetails();
            } else {
              res = await this.createBus();
            }
            if (res.success) {
              this.nextPage();
            }
            break;
          }
          case 2: {
            await this.uploadBusImages();
            break;
          }
          case 3: {
            this.addMoreRoute = true;
            this.currentStep = 3;
            break;
          }
        }
      } else if (this.currentStep === 3) {
        switch (this.page_no) {
          case 1: {
            let res = null;

            const isFormDirty = Object.values(this.v$.routeDetails).some(
              (field) => field.$dirty
            );

            if (this.route_id) {
              if (isFormDirty) {
                if (
                  this.v$.routeDetails.noOfStops.$dirty ||
                  this.v$.routeDetails.from.$dirty ||
                  this.v$.routeDetails.via.$dirty ||
                  this.v$.routeDetails.to.$dirty
                ) {
                  this.generateOrderOfStops();
                }
                this.isRouteEditing = true;
                res = await this.updateRouteDetails();
              } else {
                this.nextPage();
                this.stopLoading();
                return;
              }
            } else {
              res = await this.addRoute();
              this.generateOrderOfStops();
            }

            if (res.success) {
              this.nextPage();
            }

            this.stopLoading();
            break;
          }
          case 2: {
            await this.updateStopDetails();
            break;
          }
          case 3: {
            await this.updateFareTable();
            break;
          }
          case 4: {
            this.startLoading();
            let cleanedTrips = this.trips
              .filter((trip) => trip.trip_id >= 0)
              .map((trip) => {
                const { editable, trip_id, ...rest } = trip;
                console.log(editable, trip_id);
                return rest;
              });

            const response = await createTripSchedule(
              this.bus_id,
              this.route_id,
              cleanedTrips
            );

            if (response.success) {
              await this.getTripTimeTable(this.route_id);
              this.nextPage();
              this.stopLoading();
              this.$refs.toast.showToast("Trip Added Successfully", "success");
            } else {
              this.$refs.toast.showToast("Something went wrong", "error");
            }
            break;
          }
          case 5: {
            await this.getBusDetails(this.bus_id);
            this.busOverview = true;
          }
        }
      } else {
        switch (this.page_no) {
          case 1:
            this.currentStep = 3;
            break;
        }
      }
      this.stopLoading();
      await this.assignOperatorData();
    },

    async addOperator() {
      const response = await addOperator(
        this.operatorDetails.name,
        this.operatorDetails.email,
        this.operatorDetails.phone_number,
        this.operatorDetails.referral_code
      );
      if (response.success) {
        this.operator_id = response.data.operator_id;
        this.$refs.toast.showToast(`Operator Added Successfully`, "success");
        this.clearErrorMsg();
      } else {
        this.assignErrorMsg(response.message, "danger");
      }
      return response;
    },

    async updateOperator() {
      this.startLoading();
      const response = await updateOperator(
        this.operator_id,
        this.operatorDetails.name,
        this.operatorDetails.email,
        this.operatorDetails.phone_number,
        this.operatorDetails.referral_code
      );

      if (response.success) {
        this.clearErrorMsg();
        this.$refs.toast.showToast(
          `Operator Data Updated Successfully`,
          "success"
        );
      } else {
        this.assignErrorMsg(response.message, "danger");
        this.$refs.toast.showToast(`Failed To Edit Data`, "error");
      }
      this.stopLoading();
      this.isEditing.basic = false;
      return response;
    },

    async updateKycDetails() {
      this.clearKycDetails();
      this.kyc_value = this.kycDetails.aadhar_no || this.kycDetails.pan_no;
      let response = await updateKyc(
        this.kyc_id,
        this.kyc_type,
        this.kyc_value
      );
      if (response.success) {
        await this.assignOperatorData();
        this.$refs.toast.showToast(`Kyc Updated Successfully`, "success");
        this.nextPage();
      } else {
        this.$refs.toast.showToast(`Failed To Update Kyc`, "error");
      }
      this.isEditing.kyc = false;
    },

    async addKycDetails() {
      this.kyc_value = this.kycDetails.aadhar_no || this.kycDetails.pan_no;
      let response = await createKyc(
        this.operator_id,
        this.kyc_type,
        this.kyc_value,
        this.type
      );

      if (response.success) {
        this.$refs.toast.showToast(`Kyc Added Successfully`, "success");
        this.nextPage();
      } else {
        this.$refs.toast.showToast(`Failed To Add Kyc`, "error");
      }
      this.isEditing.kyc = false;
    },

    async createBank() {
      const response = await createBank(
        this.operator_id,
        this.bankDetails.bank_name,
        this.bankDetails.acc_number,
        this.bankDetails.ifsc_code,
        this.type
      );
      if (response.success) {
        this.$refs.toast.showToast(`Bank Data Added Successfully`, "success");
        this.clearErrorMsg();
      } else {
        this.assignErrorMsg(response.message, "danger");
        this.$refs.toast.showToast(`Failed To Add Bank`, "error");
      }
      return response;
    },

    async updateBank() {
      this.startLoading();

      const response = await updateBank(
        this.bank_id,
        this.bankDetails.bank_name,
        this.bankDetails.acc_number,
        this.bankDetails.ifsc_code
      );

      if (response.success) {
        this.operatorOverview = true;
        this.$refs.toast.showToast(
          `Bank Data Upadated Successfully`,
          "success"
        );
      } else {
        this.$refs.toast.showToast(`Failed To Upadate Bank Details`, "error");
      }
      this.isEditing.bank = false;
      this.stopLoading();

      return response;
    },

    async createBus() {
      const response = await createBus(
        this.operator_id,
        this.busBasicDetails.travelsName,
        this.busBasicDetails.busRegNo,
        this.busBasicDetails.busType,
        this.busBasicDetails.permitType,
        this.busBasicDetails.busColor,
        this.busBasicDetails.busCapacity,
        this.busBasicDetails.busMake,
        this.busBasicDetails.busDistrict,
        this.busBasicDetails.baseLocation,
        this.busBasicDetails.pincode
      );
      if (response.success) {
        this.bus_id = response.data.bus_id;
        this.$refs.toast.showToast("Bus Created Successfully!", "success");
        this.clearErrorMsg();
      } else {
        this.assignErrorMsg(response.message, "danger");
        this.$refs.toast.showToast(
          " OOPS.Failed To  Create Bus.Try Again !",
          "error"
        );
      }

      return response;
    },

    async updateBusDetails() {
      if (this.isBusEditing) {
        this.isBusLoading = true;

        const response = await updateBus(this.bus_id, this.busBasicDetails);
        if (response.success) {
          this.$refs.toast.showToast("Bus Data Edited Successfully", "success");
        } else {
          this.$refs.toast.showToast("Failed to Edit Bus Data", "error");
        }

        this.isBusLoading = false;
        this.isBusEditing = !this.isBusEditing;
        return response;
      }
      this.isBusEditing = !this.isBusEditing;
    },

    async uploadBusImages() {
      const allUploadPromises = [];

      const isFile = (val) => val instanceof File || val instanceof Blob;

      this.images.busImages.forEach((imageObj) => {
        if (imageObj.file && isFile(imageObj.file)) {
          allUploadPromises.push(
            uploadBusImage(imageObj.file, this.bus_id, imageObj.image_type)
          );
        }
      });

      if (
        !this.images.rcFrontImage.id &&
        isFile(this.images.rcFrontImage.file)
      ) {
        allUploadPromises.push(
          uploadBusImage(
            this.images.rcFrontImage.file,
            this.bus_id,
            "rc-book-front"
          )
        );
      }

      if (!this.images.rcBackImage.id && isFile(this.images.rcBackImage.file)) {
        allUploadPromises.push(
          uploadBusImage(
            this.images.rcBackImage.file,
            this.bus_id,
            "rc-book-back"
          )
        );
      }

      if (allUploadPromises.length === 0) {
        this.loading = false;
        return;
      }

      try {
        const results = await Promise.all(allUploadPromises);
        const failed = results.filter((res) => !res.status);
        if (failed.length === 0) {
          this.nextPage();
          this.$refs.toast.showToast(
            "All images uploaded successfully!",
            "success"
          );
        } else {
          const messages = failed.map((res) => res.message).join("; ");
          this.$refs.toast.showToast(
            `Some uploads failed: ${messages}`,
            "error"
          );
        }
      } catch (err) {
        this.$refs.toast.showToast(
          err.response?.data?.message || "Unexpected upload error.",
          "error"
        );
      } finally {
        this.images.busImages = [];
        this.loading = false;
      }
    },
    async updateBusImage(imageId, image, imageType) {
      const response = await updateBusImage(imageId, image, imageType);
      if (response.success) {
        this.$refs.toast.showToast("Image Updated Successfully", "success");
      } else {
        this.$refs.toast.showToast("Failed to Update bus image", "error");
      }
    },

    async deleteImage(imgID, index) {
      if (imgID) {
        const response = await deleteBusImage(imgID);
        if (response.success) {
          this.images.busImages.splice(index, 1);

          this.$refs.toast.showToast("Image Delete Successfully", "success");
        } else {
          this.$refs.toast.showToast("Failed to delete bus image", "error");
        }
      } else {
        this.images.busImages.splice(index, 1);

        this.$refs.toast.showToast("Image removed", "success");
      }
    },

    isTypeSelected(type, currentIndex) {
      return this.images.busImages.some(
        (img, i) => img.image_type === type && i !== currentIndex
      );
    },

    async updateRouteDetails() {
      if (!this.isRouteEditing) {
        this.isRouteEditing = true;
        return;
      }

      this.isRouteLoading = true;

      const response = await updateRoute(
        this.route_id,
        this.routeDetails,
        this.order_of_stops
      );

      if (response.success) {
        this.$refs.toast.showToast("Route Data Edited Successfully", "success");
      } else {
        this.$refs.toast.showToast("Failed to Edit Route Data", "error");
      }

      this.isRouteLoading = false;
      this.isRouteEditing = false;

      return response;
    },
    async addRoute() {
      const response = await addRoute({
        bus_id: this.bus_id,
        source: this.routeDetails.from,
        destination: this.routeDetails.to,
        via_locations: this.routeDetails.via,
        total_stops: Number(this.routeDetails.noOfStops),
        order_of_stops: this.order_of_stops,
        total_distance: Number(this.routeDetails.totalKm),
        total_duration: this.routeDetails.total_duration,
        min_fare: Number(this.routeDetails.minimumFare),
        max_fare: Number(this.routeDetails.maximumFare),
        luggage_fare_per_unit: Number(this.routeDetails.luggageFare),
      });
      if (response.success) {
        this.clearErrorMsg();
        this.route_id = response.data.route_id;
        this.$refs.toast.showToast("Route Created Successfully!", "success");
      } else {
        this.assignErrorMsg(response.message, "danger");
        this.$refs.toast.showToast("Failed to add route.Try Again.", "error");
      }

      return response;
    },

    async updateStopDetails() {
      const response = await updateRoute(
        this.route_id,
        this.routeDetails,
        this.order_of_stops
      );
      if (response.status) {
        await this.getFareTable();
        this.clearErrorMsg();
        this.$refs.toast.showToast("Stop Added Successfully!", "success");
        this.nextPage();
      } else {
        this.assignErrorMsg(response.message, "danger");
        this.$refs.toast.showToast("FAiled to Add Stop.Try Again!", "error");
      }
    },

    async editBusDetails(bus_id, routeID = null) {
      this.loaderLoading = true;

      this.bus_id = bus_id;
      this.v$.$reset();
      const response = await this.getBusDetails(bus_id, routeID);

      if (response.success) {
        this.addMoreBus = false;
          this.addMoreRoute = false;
          this.busOverview = false;
        if (response.data.onboarding_progress === 100) {
          this.isOverallEdit = true;
          this.maxCurrentStep = 4;
        } else {
          this.isOverallEdit = false;
          if (!routeID) this.checkProgress(bus_id);
        }
      }
      this.loaderLoading = false;
    },

    editFareTable() {
      this.toggleEdit();
      this.updateFareTable();
    },

    async updateFareTable() {
      if (!this.isFareTableEditing) {
        this.loading = true;
        const cleanedFares = this.fares
          .filter((f) => f.bus_stop_id)
          .map((f) => ({
            stop1: f.stop1,
            stop2: f.stop2,
            fare: f.fare,
            bus_stop_id: f.bus_stop_id,
          }));

        const response = await patchFareTable(
          this.bus_id,
          this.route_id,
          cleanedFares
        );
        if (response.success) {
          this.msgTxt = "";
          this.msgType = "";
          this.$refs.toast.showToast("Price Added Successfully!", "success");
          this.nextPage();
        } else {
          this.msgTxt = response.message;
          this.msgType = response.type;
          this.$refs.toast.showToast(
            "OOPS. Failed to Add Price.Try Again!",
            "error"
          );
        }
        this.loading = false;
      }
    },

    async submitBusDetails() {
      this.startLoading();
      await this.assignOperatorData();
      this.stopLoading();
      this.busOverview = false;
      this.addMoreRoute = true
    },

    calculateTotalDuration(upTrips, downTrips) {
      const parseTime = (timeStr) => {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      };

      const allTimes = [...upTrips, ...downTrips].filter(Boolean);
      if (allTimes.length < 2) return null;

      const sorted = allTimes.map(parseTime).sort((a, b) => a - b);
      const totalMinutes = sorted[sorted.length - 1] - sorted[0];

      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours}h ${minutes}m`;
    },

    async assignOperatorData() {
      const response = await getOperatorById(this.operator_id);
      if (response.success) {
        this.storeEditData(response.data);
        this.getEditData();
        const {
          name,
          email,
          phone_number,
          referral_code,
          kyc_details,
          bank_details,
          bus_details,
          staff_details,
        } = response.data;

        Object.assign(this.operatorDetails, {
          name,
          email,
          phone_number,
          referral_code,
        });

        if (kyc_details.length >= 1) {
          const { kyc_id, kyc_type, kyc_value } = kyc_details[0];
          this.kyc_id = kyc_id;
          this.kyc_type = kyc_type;
          this.kyc_value = kyc_value;

          this.kycDetails[kyc_type === "aadhar" ? "aadhar_no" : "pan_no"] =
            kyc_value;
        }

        if (bank_details.length >= 1) {
          const { bank_id, bank_name, account_number, ifsc_code } =
            bank_details[0];

          this.bank_id = bank_id;
          this.bankDetails.bank_name = bank_name;
          this.bankDetails.acc_number = account_number;
          this.bankDetails.cnf_acc_no = account_number;
          this.bankDetails.ifsc_code = ifsc_code;
        }

        await this.fetchCityList();

        if (bus_details.length >= 1) {
          this.bus_id = bus_details[bus_details.length - 1].bus_id;
          this.totalNoOfBuses = bus_details;
        }

        this.staffData = staff_details;
      }
    },

    async getFareTable() {
      const response = await getFareTable(this.bus_id, this.route_id);
      if (response.status) {
        this.fares = response.raw_table;
      }
    },

    async addStaff() {
      if (this.staff_id) {
        await this.updateStatus();
      } else {
        const response = await createStaff(this.bus_id, this.staffdetails.name);
        console.log("STaff Response", response);
      }
    },

    // async getTripTimeTable(routeID) {
    //   const response = await getTripTimeTable(this.bus_id);
    //   const allTrips = [];

    //   response.data.forEach((route) => {
    //     route.trips.forEach((trip) => {
    //       allTrips.push({
    //         ...trip,
    //         time_table_obj: this.convertArrayToObject(trip.time_table ?? []),
    //       });
    //     });
    //   });

    //   this.timetables = allTrips;
    //   this.displayTimetables = JSON.parse(JSON.stringify(allTrips));
    // },
    async getTripTimeTable(routeID) {
      const response = await getTripTimeTable(this.bus_id);

      const allTrips = [];

      response.data
        .filter((route) => route.route_id === routeID)
        .forEach((route) => {
          route.trips.forEach((trip) => {
            allTrips.push({
              ...trip,
              time_table_obj: this.convertArrayToObject(trip.time_table ?? []),
            });
          });
        });

      this.timetables = allTrips;
      this.displayTimetables = structuredClone(allTrips);
    },

    convertArrayToObject(time_table) {
      const obj = {};
      if (!Array.isArray(time_table)) {
        console.warn("Invalid time_table:", time_table);
        return obj;
      }

      time_table.forEach((entry) => {
        if (entry?.stop_name && entry?.expected_time) {
          obj[entry.stop_name] = entry.expected_time;
        }
      });

      return obj;
    },

    // Kyc Type
    toggleSelection(option) {
      this.kyc_type = this.kyc_type === option ? null : option;
    },

    startEditing() {
      this.originalTimetables = JSON.parse(
        JSON.stringify(this.displayTimetables)
      );
      this.isTimeTableEditing = true;
      this.originalTimeTableData = JSON.parse(
        JSON.stringify(this.displayTimetables)
      );
    },

    cancelChanges() {
      this.displayTimetables = JSON.parse(
        JSON.stringify(this.originalTimeTableData)
      );
      this.isTimeTableEditing = false;
    },
    async saveChanges() {
      const changes = [];

      this.displayTimetables.forEach((timetable, index) => {
        const original = this.originalTimetables[index];

        if (timetable.trip_start_time !== original.trip_start_time) {
          changes.push({
            trip_id: timetable.trip_id,
            type: "start_time",
            time: timetable.trip_start_time,
          });
        }

        for (const stop in timetable.time_table_obj) {
          if (
            timetable.time_table_obj[stop] &&
            timetable.time_table_obj[stop] !== original.time_table_obj[stop]
          ) {
            changes.push({
              // trip_id: timetable.trip_id,
              stop_name: stop,
              expected_time: timetable.time_table_obj[stop],
            });
          }
        }
      });

      if (changes.length) {
        const response = await updateTripTimeTable(this.bus_id, changes);
        if (response.success) {
          this.isTimeTableEditing = false;
          await this.getTripTimeTable();
        } else {
          console.error("Update failed", response);
        }
      } else {
        console.log("No changes made");
      }
    },

    handleBusImageUpload(event) {
      const files = Array.from(event.target.files);

      const defaultTypes = ["primary", "back", "cover", "inside", "other"];

      files.forEach((file) => {
        if (file && this.images.busImages.length < 6) {
          const index = this.images.busImages.length;
          const type = defaultTypes[index] || "other";

          this.images.busImages.push({
            file,
            image_url: URL.createObjectURL(file),
            image_type: type,
          });
        }
      });

      event.target.value = null;
    },

    async handleRcFrontUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.previrwRcFront = URL.createObjectURL(file);
        if (this.images.rcFrontImage.file && this.images.rcFrontImage.id) {
          await this.updateBusImage(
            this.images.rcFrontImage.id,
            this.images.rcFrontImage,
            "rc-book-front"
          );
        }
        this.images.rcFrontImage.file = file;
      }
    },

    async handleRcBackUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.previewRcBack = URL.createObjectURL(file);
        if (this.images.rcBackImage.file && this.images.rcBackImage.id) {
          await this.updateBusImage(
            this.images.rcBackImage.id,
            this.images.rcBackImage,
            "rc-book-back"
          );
        }
        this.images.rcBackImage.file = file;
      }
    },

    toggleEdit() {
      this.isFareTableEditing = !this.isFareTableEditing;
    },

    async checkProgress(busID) {
      const busDetails = this.userEditData?.bus_details || [];

      let selectedBus = null;
      if (busID) {
        selectedBus = busDetails.find((bus) => bus.bus_id === busID);
      } else if (busDetails.length > 0) {
        selectedBus = busDetails[busDetails.length - 1];
      }

      if (
        this.userEditData.onboarding_progress === 20 &&
        this.userEditData.onboarding_state === "KYC"
      ) {
        this.currentStep = 1;
        this.maxCurrentStep = 1;
        this.page_no = 2;
        this.max_step = 2;
      } else if (
        this.userEditData.onboarding_progress === 30 &&
        this.userEditData.onboarding_state === "BANK_DETAILS"
      ) {
        this.currentStep = 1;
        this.maxCurrentStep = 1;
        this.page_no = 3;
        this.max_step = 3;
      } else if (
        this.userEditData.onboarding_progress === 40 &&
        this.userEditData.onboarding_state === "OPERATOR_SUMMARY"
      ) {
        this.currentStep = 1;
        this.maxCurrentStep = 1;
        this.operatorOverview = true;
      } else if (
        (this.userEditData.onboarding_progress === 50 &&
          this.userEditData.onboarding_state === "BUS_DETAILS") ||
        (this.userEditData.onboarding_progress === 100 &&
          this.userEditData.onboarding_state === "ONBOARDING_COMPLETE") ||
        (this.userEditData.onboarding_progress === 70 &&
          this.userEditData.onboarding_state === "STAFF_DETAILS")
      ) {
        this.currentStep = 2;
        this.maxCurrentStep = 3;
        this.page_no = 1;
        this.max_step = 1;
        this.addMoreBus = true;
        if (selectedBus) {
          const progress = selectedBus.onboarding_progress;
          const state = selectedBus.onboarding_state;

          console.log(progress,state)
          if (progress === 0 && state === "BUS_IMAGES") {
            this.max_step = 2;
            this.page_no = 2;
          } else if (progress === 20 && state === "ROUTE_DETAILS") {
            this.max_step = 3;
            this.page_no = 3;
          } else if (progress === 30 && state === "STOP_DETAILS") {
            this.max_step = 4;
            this.page_no = 4;
            this.generateOrderOfStops();
          } else if (progress === 40 && state === "FARE_DETAILS") {
            this.max_step = 5;
            this.page_no = 5;
          } else if (progress === 50 && state === "TRIP_DETAILS") {
            this.max_step = 6;
            this.page_no = 6;
          } else if (progress === 60 && state === "BUS_SUMMARY") {
            await this.getTripTimeTable();
            this.max_step = 7;
            this.page_no = 7;
          }
        }
      }
    },
  },

  validations: {
    operatorDetails: {
      name: {
        required: helpers.withMessage("Name is required", required),
        noNumbers: helpers.withMessage(
          "Name must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      email: { required, email },
      phone_number: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      referral_code: {},
    },
    kycDetails: {
      aadhar_no: {
        required: helpers.withMessage("Aadhar number is required", required),
        numeric: helpers.withMessage("Aadhar number must be numeric", numeric),
        minLength: helpers.withMessage(
          "Aadhar number must be 4 digits",
          minLength(4)
        ),
        maxLength: helpers.withMessage(
          "Aadhar number must be 4 digits",
          maxLength(4)
        ),
      },
      pan_no: {
        required,
        panValidation: helpers.withMessage(
          "Invalid PAN number format",
          (value) => /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(value)
        ),
      },
    },
    bankDetails: {
      bank_name: {
        required: helpers.withMessage("Bank name is required", required),
        noNumbers: helpers.withMessage(
          "Bank name must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      acc_number: {
        required: helpers.withMessage("Account number is required", required),
        minLength: helpers.withMessage(
          "Account number must be at least 8 digits",
          minLength(8)
        ),
        maxLength: helpers.withMessage(
          "Account number cannot exceed 18 digits",
          maxLength(18)
        ),
      },
      cnf_acc_no: {
        required: helpers.withMessage(
          "Confirm Account Number is required",
          required
        ),
        sameAsAcc: helpers.withMessage(
          "Account numbers do not match",
          (value, vm) => {
            return vm.acc_number && value === vm.acc_number;
          }
        ),
      },
      ifsc_code: {
        required: helpers.withMessage("IFSC code is required", required),
        ifscValidation: helpers.withMessage(
          "Invalid IFSC format (e.g., SBIN0001234)",
          (value) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(value)
        ),
      },
    },
    busBasicDetails: {
      travelsName: {
        required: helpers.withMessage("Travels Name is required", required),
      },
      busRegNo: {
        required: helpers.withMessage(
          "Bus Registration Number is required",
          required
        ),
      },
      busType: {
        required: helpers.withMessage("Bus Type is required", required),
      },
      permitType: {
        required: helpers.withMessage("Permit Type is required", required),
      },
      busColor: {
        required: helpers.withMessage("Bus Color is required", required),
        noNumbers: helpers.withMessage(
          "Bus  Color must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      busCapacity: {
        required: helpers.withMessage("Bus Capacity is required", required),
        numeric: helpers.withMessage("Bus Capacity must be a number", numeric),
      },
      busMake: {
        required: helpers.withMessage("Bus Make is required", required),
      },
      busDistrict: {
        required: helpers.withMessage("Bus District is required", required),
        noNumbers: helpers.withMessage(
          "Bus District must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      baseLocation: {
        required: helpers.withMessage("Base Location is required", required),
        noNumbers: helpers.withMessage(
          "Base Location must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      pincode: {
        required: helpers.withMessage("Pincode is required", required),
        numeric: helpers.withMessage("Pincode must be a number", numeric),
      },
    },
    images: {
      busImages: {
        required,
        minLength: minLength(1),
      },
      rcFrontImage: {
        file: { required },
      },
      rcBackImage: {
        file: { required },
      },
    },
    routeDetails: {
      from: {
        required: helpers.withMessage("From location is required", required),
        noNumbers: helpers.withMessage(
          "From must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      via: {
        required: helpers.withMessage("Via location is required", required),
        noNumbers: helpers.withMessage(
          "via must not contain numbers",
          (value) => /^[^0-9]*$/.test(value)
        ),
      },
      to: {
        required: helpers.withMessage("To location is required", required),
        noNumbers: helpers.withMessage("To must not contain numbers", (value) =>
          /^[^0-9]*$/.test(value)
        ),
      },
      noOfStops: {
        required: helpers.withMessage("Number of Stops is required", required),
        numeric: helpers.withMessage(
          "Number of Stops must be a number",
          numeric
        ),
      },
      totalKm: {
        required: helpers.withMessage("Total Kilometers is required", required),
        numeric: helpers.withMessage(
          "Total Kilometers must be a number",
          numeric
        ),
      },
      minimumFare: {
        required: helpers.withMessage("Minimum Fare is required", required),
        numeric: helpers.withMessage("Minimum Fare must be a number", numeric),
      },
      maximumFare: {
        required: helpers.withMessage("Maximum Fare is required", required),
        numeric: helpers.withMessage("Maximum Fare must be a number", numeric),
      },
      luggageFare: {
        required: helpers.withMessage("Luggage Fare is required", required),
        numeric: helpers.withMessage("Luggage Fare must be a number", numeric),
      },
      total_trips: {
        required: helpers.withMessage("Total trips is required", required),
        numeric: helpers.withMessage("Total trips must be a number", numeric),
      },
      total_uptrips: {
        required: helpers.withMessage("Total uptrips is required", required),
        numeric: helpers.withMessage("Total uptrips must be a number", numeric),
      },
      total_downtrips: {
        required: helpers.withMessage("Total downtrips is required", required),
        numeric: helpers.withMessage(
          "Total downtrips must be a number",
          numeric
        ),
      },
      total_duration: {
        required: helpers.withMessage("Total duration is required", required),
      },
    },
    order_of_stops: {
      $each: {
        stop: { required },
        time: { required, numeric },
        distance: { required, numeric },
      },
    },
    staffdetails: {
      name: { required, minLength: minLength(3) },
      role: { required },
      phone_number: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      linked_buses: { required, atLeastOne },
    },
  },

  computed: {
    ...mapState(useAuthStore, ["ldata"]),
    ...mapState(useUserStore, ["type", "userEditData"]),

    progressWidth() {
      let totalPages = 0;
      if (this.currentStep === 1 && Array.isArray(this.operatorSubtitle)) {
        totalPages = this.operatorSubtitle.length;
      } else if (this.currentStep === 2 && Array.isArray(this.busSubtitle)) {
        totalPages = this.busSubtitle.length;
      } else if (this.currentStep === 3 && Array.isArray(this.routeSubtitle)) {
        totalPages = this.routeSubtitle.length;
      }

      if (totalPages <= 1) return "100%";

      const progress = ((this.page_no - 1) / (totalPages - 1)) * 100;
      return `${progress}%`;
    },

    isCurrentTabValid() {
      if (!this.v$) return false;
      if (this.currentStep === 1) {
        switch (this.page_no) {
          case 1:
            return !this.v$.operatorDetails.$invalid;
          case 2:
            return (
              !this.v$.kycDetails.pan_no.$invalid ||
              !this.v$.kycDetails.aadhar_no.$invalid
            );
          case 3:
            return !this.v$.bankDetails.$invalid;
          case 4:
          case 5:
            return true;
          default:
            return false;
        }
      } else if (this.currentStep === 2) {
        switch (this.page_no) {
          case 1:
            return !this.v$.busBasicDetails.$invalid;
          case 2:
            return !this.v$.images.$invalid;
          default:
            return true;
        }
      } else if (this.currentStep === 3) {
        switch (this.page_no) {
          case 1:
            return (
              !this.v$.routeDetails?.from.$invalid &&
              !this.v$.routeDetails?.to.$invalid &&
              !this.v$.routeDetails?.noOfStops.$invalid &&
              !this.v$.routeDetails?.totalKm.$invalid &&
              !this.v$.routeDetails?.minimumFare.$invalid &&
              !this.v$.routeDetails?.maximumFare.$invalid &&
              !this.v$.routeDetails?.luggageFare.$invalid
            );
          case 2:
            return !this.v$.order_of_stops.$invalid;
          case 3:
          case 4:
          case 5:
          case 6:
            return true;
          default:
            return false;
        }
      }
      return false;
    },

    isStaffValid() {
      if (!this.v$) return false;
      return !this.v$.staffdetails.$invalid;
    },

    uniqueStops() {
      const stops = new Set();
      this.displayTimetables.forEach((tt) => {
        Object.keys(tt.time_table_obj).forEach((stop) => stops.add(stop));
      });
      return Array.from(stops);
    },
  },

  async mounted() {
    this.loaderLoading = true;
    this.subtitle = this.operatorSubtitle;
    this.getEditData();
    if (this.userEditData) {
      this.operator_id = this.userEditData.operator_id;
      await this.assignOperatorData();
      if (this.userEditData.onboarding_progress === 100) {
        this.isOverallEdit = true;
        this.maxCurrentStep = 5;
        this.max_step = 10;
      } else {
        this.isOverallEdit = false;
        this.maxCurrentStep = this.currentStep; // default to current
        this.max_step = 1;
        this.checkProgress();
      }
    }
    this.loaderLoading = false;
  },

  created() {
    this.v$ = useVuelidate(this.$options.validations, this);
  },
};
</script>

<style>
@keyframes loaderAnim {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>

<style scoped>
.fare-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  font-family: "Segoe UI", sans-serif;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.clickable-step {
  cursor: pointer;
}

.fare-table th,
.fare-table td {
  border: 1px solid #e0e0e0;
  padding: 10px;
  text-align: center;
  font-size: 14px;
}

.fare-table thead th {
  background-color: #f5f5f5;
  font-weight: 600;
  color: #333;
}

.fare-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.fare-input {
  width: 60px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
}
.box-shadow {
  box-shadow: 0px 0px 10px rgb(220, 218, 218, 0.5);
}
.error-message {
  color: red;
  font-size: 11px;
  display: flex;
  align-items: center;
  margin-top: 2px;
}
.upload-area {
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  text-align: center;
  padding: 40px 20px;
  cursor: pointer;
  transition: border-color 0.3s;
}
.upload-area:hover {
  border-color: #9ca3af;
}
.upload-area input {
  display: none;
}
.upload-area i {
  font-size: 2.5rem;
  color: #6b7280;
}
.upload-area p {
  margin-bottom: 0;
  font-weight: 500;
}
.upload-area small {
  color: #6b7280;
}

.btn-grey {
  background-color: #d6d6d6 !important;
  color: #a5a5a5 !important;
  border-color: #d6d6d6 !important;
  cursor: not-allowed;
}

.fare-matrix-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.fare-matrix-table th,
.fare-matrix-table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

.fare-matrix-table thead th {
  background-color: #2b6cb0;
  color: white;
}

.from-stop {
  background-color: #2d3748;
  color: white;
  font-weight: bold;
}

.fare-instructions {
  margin-top: 20px;
  font-size: 14px;
}

.fare-instructions ul {
  padding-left: 20px;
}

.input-container {
  height: 75px;
}
.role-label {
  background-color: white;
  padding: 4px 8px;
  border-radius: 12px;
  border: 2px solid transparent;
  font-weight: bold;
}

/* Role-specific outline colors */
.conductor {
  border-color: blue;
  color: blue;
}

.driver {
  border-color: green;
  color: green;
}

.checker {
  border-color: orange;
  color: orange;
}

.image-wrapper {
  position: relative;
}

.image-card img {
  height: 150px;
  object-fit: cover;
  width: 100%;
  border-radius: 4px;
}

.delete-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 4px 6px;
  font-size: 22px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.delete-icon:hover {
  transform: scale(1.1);
  background: rgba(255, 0, 0, 0.8);
}

.disabled-step {
  pointer-events: none;
  opacity: 0.5;
}
</style>
